import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, isRef as _isRef, withKeys as _withKeys, vShow as _vShow, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "fcw-av-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "fcw-av-snooze"
}
const _hoisted_5 = { class: "fcw-head-info" }
const _hoisted_6 = { class: "fcw-head-name" }
const _hoisted_7 = {
  key: 0,
  class: "fcw-head-doc"
}
const _hoisted_8 = { class: "fcw-head-sub" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 2,
  class: "fcw-agent-tag"
}
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 0,
  class: "fcw-status-menu"
}
const _hoisted_13 = {
  key: 1,
  class: "fcw-snz"
}
const _hoisted_14 = { class: "fcw-snz-row" }
const _hoisted_15 = { class: "fcw-snz-btns" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  key: 0,
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_19 = {
  key: 1,
  width: "11",
  height: "11",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_20 = { class: "fcw-lbls" }
const _hoisted_21 = {
  key: 2,
  class: "fcw-agent-menu"
}
const _hoisted_22 = { class: "fcw-agent-search-wrap" }
const _hoisted_23 = {
  key: 0,
  style: {"padding":"12px","display":"flex","justify-content":"center"}
}
const _hoisted_24 = {
  key: 1,
  class: "fcw-agent-list"
}
const _hoisted_25 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["title"]
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_31 = {
  key: 2,
  class: "fcw-agent-menu"
}
const _hoisted_32 = { class: "fcw-agent-search-wrap" }
const _hoisted_33 = {
  key: 0,
  style: {"padding":"12px","display":"flex","justify-content":"center"}
}
const _hoisted_34 = {
  key: 1,
  class: "fcw-agent-list"
}
const _hoisted_35 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e","flex-shrink":"0"}
}
const _hoisted_38 = ["title"]
const _hoisted_39 = {
  width: "7",
  height: "7",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  style: {"flex-shrink":"0"}
}
const _hoisted_40 = {
  key: 0,
  class: "fcw-p-spin"
}
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  width: "7",
  height: "7",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_43 = {
  key: 1,
  class: "fcw-p-spin"
}
const _hoisted_44 = {
  key: 2,
  class: "fcw-priority-menu"
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 1,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_47 = {
  key: 2,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e"}
}
const _hoisted_48 = ["onClick", "disabled"]
const _hoisted_49 = {
  key: 1,
  class: "fcw-lbl-lock",
  width: "9",
  height: "9",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  title: "Etiqueta protegida — não pode ser removida"
}
const _hoisted_50 = {
  key: 3,
  class: "fcw-lbl-picker"
}
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 0,
  class: "fcw-lbl-dropdown"
}
const _hoisted_53 = {
  key: 0,
  class: "fcw-lbl-loading"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"var(--ink-40)"},
  title: "Etiqueta protegida — não pode ser removida"
}
const _hoisted_56 = {
  key: 1,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","color":"#22c55e"}
}
const _hoisted_57 = {
  key: 0,
  class: "fcw-snooze-banner"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  key: 0,
  class: "fcw-msg-search-count"
}
const _hoisted_61 = {
  key: 2,
  class: "fcw-macro-panel"
}
const _hoisted_62 = { class: "fcw-macro-head" }
const _hoisted_63 = { class: "fcw-macro-search-wrap" }
const _hoisted_64 = { class: "fcw-macro-count" }
const _hoisted_65 = {
  key: 0,
  class: "fcw-macro-loading"
}
const _hoisted_66 = {
  key: 1,
  class: "fcw-macro-results"
}
const _hoisted_67 = { class: "fcw-macro-results-title" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { class: "fcw-macro-steps" }
const _hoisted_70 = { class: "fcw-macro-step-icon" }
const _hoisted_71 = {
  key: 0,
  width: "9",
  height: "9",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_72 = {
  key: 1,
  width: "9",
  height: "9",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_73 = { class: "fcw-macro-step-body" }
const _hoisted_74 = { class: "fcw-macro-step-label" }
const _hoisted_75 = {
  key: 0,
  class: "fcw-macro-step-err"
}
const _hoisted_76 = {
  key: 0,
  class: "fcw-macro-step fcw-macro-step--pending"
}
const _hoisted_77 = { class: "fcw-macro-step-body" }
const _hoisted_78 = { class: "fcw-macro-step-label" }
const _hoisted_79 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_80 = {
  key: 1,
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_81 = { key: 2 }
const _hoisted_82 = { key: 3 }
const _hoisted_83 = {
  key: 2,
  class: "fcw-macro-list"
}
const _hoisted_84 = {
  key: 0,
  class: "fcw-macro-empty"
}
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "fcw-macro-item-info" }
const _hoisted_87 = { class: "fcw-macro-item-name" }
const _hoisted_88 = { class: "fcw-macro-item-count" }
const _hoisted_89 = {
  key: 0,
  class: "fcw-msgs-loading"
}
const _hoisted_90 = {
  key: 0,
  class: "fcw-msgs-loading-label"
}
const _hoisted_91 = {
  key: 0,
  class: "fcw-load-more-row"
}
const _hoisted_92 = {
  key: 1,
  class: "fcw-no-more"
}
const _hoisted_93 = ["data-msg-id"]
const _hoisted_94 = {
  key: 0,
  class: "fcw-msg-act"
}
const _hoisted_95 = ["title"]
const _hoisted_96 = ["src"]
const _hoisted_97 = { key: 1 }
const _hoisted_98 = {
  key: 1,
  class: "fcw-msg-av-spacer"
}
const _hoisted_99 = { class: "fcw-bubble" }
const _hoisted_100 = {
  key: 0,
  class: "fcw-priv-tag"
}
const _hoisted_101 = ["innerHTML"]
const _hoisted_102 = ["href"]
const _hoisted_103 = ["href"]
const _hoisted_104 = ["src"]
const _hoisted_105 = {
  key: 1,
  class: "fcw-ap"
}
const _hoisted_106 = ["onClick"]
const _hoisted_107 = {
  key: 0,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_108 = {
  key: 1,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_109 = { class: "fcw-ap-mid" }
const _hoisted_110 = ["value", "onInput"]
const _hoisted_111 = { class: "fcw-ap-time" }
const _hoisted_112 = ["href"]
const _hoisted_113 = {
  key: 2,
  class: "fcw-att-video-wrap"
}
const _hoisted_114 = ["src"]
const _hoisted_115 = ["href"]
const _hoisted_116 = { class: "fcw-att-info" }
const _hoisted_117 = { class: "fcw-att-size" }
const _hoisted_118 = ["href"]
const _hoisted_119 = { class: "fcw-att-info" }
const _hoisted_120 = { class: "fcw-att-ext" }
const _hoisted_121 = { class: "fcw-att-size" }
const _hoisted_122 = { class: "fcw-bubble-ts" }
const _hoisted_123 = ["title"]
const _hoisted_124 = {
  key: 0,
  width: "8",
  height: "8",
  viewBox: "0 0 8 8",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}
const _hoisted_125 = {
  key: 1,
  width: "14",
  height: "8",
  viewBox: "0 0 14 8",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_126 = {
  key: 2,
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_127 = {
  key: 3,
  class: "fcw-readonly-banner"
}
const _hoisted_128 = {
  key: 4,
  class: "fcw-window-banner"
}
const _hoisted_129 = {
  key: 5,
  class: "fcw-files"
}
const _hoisted_130 = ["onClick"]
const _hoisted_131 = ["disabled"]
const _hoisted_132 = ["disabled", "title"]
const _hoisted_133 = ["placeholder", "disabled"]
const _hoisted_134 = ["disabled"]
const _hoisted_135 = {
  key: 0,
  class: "fcw-spinner-sm-white"
}
const _hoisted_136 = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_137 = {
  key: 7,
  class: "fcw-recording"
}
const _hoisted_138 = { class: "fcw-rec-wave" }
const _hoisted_139 = { class: "fcw-rec-time" }
const _hoisted_140 = {
  key: 8,
  class: "fcw-rec-preview"
}
const _hoisted_141 = ["src"]
const _hoisted_142 = { class: "fcw-tpl-dialog" }
const _hoisted_143 = { class: "fcw-tpl-head" }
const _hoisted_144 = { class: "fcw-tpl-title" }
const _hoisted_145 = { class: "fcw-tpl-contact" }
const _hoisted_146 = { class: "fcw-tpl-body" }
const _hoisted_147 = { class: "fcw-tpl-list-col" }
const _hoisted_148 = {
  key: 0,
  class: "fcw-tpl-loading"
}
const _hoisted_149 = {
  key: 1,
  class: "fcw-tpl-empty"
}
const _hoisted_150 = {
  key: 2,
  class: "fcw-tpl-items"
}
const _hoisted_151 = ["onClick"]
const _hoisted_152 = { class: "fcw-tpl-item-name" }
const _hoisted_153 = { class: "fcw-tpl-item-meta" }
const _hoisted_154 = { class: "fcw-tpl-lang" }
const _hoisted_155 = { class: "fcw-tpl-config-col" }
const _hoisted_156 = {
  key: 0,
  class: "fcw-tpl-pick-hint"
}
const _hoisted_157 = { class: "fcw-tpl-preview-wrap" }
const _hoisted_158 = { class: "fcw-tpl-bubble" }
const _hoisted_159 = {
  key: 0,
  class: "fcw-tpl-bubble-img"
}
const _hoisted_160 = ["src"]
const _hoisted_161 = {
  key: 1,
  class: "fcw-tpl-img-ph"
}
const _hoisted_162 = {
  key: 1,
  class: "fcw-tpl-bubble-hdr"
}
const _hoisted_163 = ["innerHTML"]
const _hoisted_164 = {
  key: 2,
  class: "fcw-tpl-bubble-ftr"
}
const _hoisted_165 = { class: "fcw-tpl-bubble-time" }
const _hoisted_166 = {
  key: 0,
  class: "fcw-tpl-btns"
}
const _hoisted_167 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_168 = {
  key: 1,
  style: {"margin-top":"12px"}
}
const _hoisted_169 = { class: "fcw-tpl-field-label" }
const _hoisted_170 = {
  key: 0,
  class: "fcw-tpl-mapped-badge"
}
const _hoisted_171 = ["placeholder", "value", "onInput"]
const _hoisted_172 = { style: {"margin-top":"16px"} }
const _hoisted_173 = {
  key: 0,
  class: "fcw-tpl-blocked-hint"
}
const _hoisted_174 = ["disabled", "title"]
const _hoisted_175 = { key: 0 }
const _hoisted_176 = {
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"vertical-align":"-2px","margin-right":"5px"}
}
const _hoisted_177 = {
  key: 1,
  class: "fcw-tpl-spin",
  style: {"border-top-color":"#fff","border-color":"rgba(255,255,255,.3)"}
}

import { ref, computed, nextTick, watch, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import type { FloatWindow } from '@/composables/useFloatChats'
import { useFloatChats } from '@/composables/useFloatChats'
import { avatarColor, initials, conversationDocument, isFluxoGeral, confirmAssignDuringFluxoGeral, confirmResolveConversation } from '@/composables/useHelpers'
import { useSLA } from '@/composables/useSLA'
import { usePermission } from '@/composables/usePermission'
import Swal from 'sweetalert2'
import EmojiPicker from '@/components/dashboard/EmojiPicker.vue'
import { n8nDownloadUrl } from '@/api/n8n'
import { snoozeConversation } from '@/services/snoozeService'
import { listMacros, type MacroAction } from '@/services/macrosService'
import { listTeams, listTeamMembersOrAgents, type TeamItem } from '@/services/teamsService'
import { isLabelProtected } from '@/composables/useProtectedLabels'
import {
  toggleConversationStatus, assignAgentViaSystem, assignTeam, logManualAssignment,
  fetchAccountLabels, setConversationLabels,
} from '@/services/conversationActionsService'
import { runMacroAction, resolveConversationSmart, MACRO_ACTION_LABELS, type MacroActionContext } from '@/services/macroEngineService'
import { useConversationStore } from '@/composables/useConversationStore'
import { fetchMessages, fetchOlderMessages } from '@/services/messagesService'
import { useMessageCache } from '@/composables/useMessageCache'
import { onConversationMessage } from '@/composables/useChatwootMessageRealtime'
import { useMessageSearch } from '@/composables/useMessageSearch'
import { getFileType, isVideo, isPdf, fmtSize, extractFileKey } from '@/composables/useMediaHelpers'
import { useAudioRecorder } from '@/composables/useAudioRecorder'
import { useWhatsappTemplates } from '@/composables/useWhatsappTemplates'
import { useMessageSender } from '@/composables/useMessageSender'
import { useMessageWindow } from '@/composables/useMessageWindow'
import { CHATWOOT_BASE, authHeaders } from '@/api/chatwoot'
import type { ChatMessage, ProcessedMsg, LabelItem, AgentItem, Priority, SLABadge } from '@/types/chat'
import { PRIORITY_LABELS, PRIORITY_COLORS } from '@/types/chat'
import { allAgents } from '@/composables/useDashboardEngine'
import { playNotificationSound } from '@/composables/useNotificationSound'

const MIN_W = 280, MIN_H = 360, MAX_W = 700, MAX_H = 860

interface MacroItem { id: string; name: string; description: string; actions: MacroAction[]; team_ids: number[]; is_active: boolean }


export default /*@__PURE__*/_defineComponent({
  __name: 'FloatChatWindow',
  props: {
    win: {}
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props


const { windows, bringToFront } = useFloatChats()
// Referência mutável ao objeto na store (evita mutação direta de prop)
const mw = computed(() => windows.value.find(w => w.uid === props.win.uid)!)
const { conversations } = useConversationStore()
const store         = useStore()
const authUser      = computed(() => store.getters.authUser)
const { can, allowedTeamIds } = usePermission()
const canAssignTeam            = computed(() => can('messages.assignTeam'))

const API = `${CHATWOOT_BASE}/api/v1/accounts/3`
function apiHeaders() { return authHeaders(authUser.value?.access_token || '') }
function apiUrl(path: string) { return `${API}${path}?api_access_token=${authUser.value?.access_token || ''}` }

const {
  tplOpen: tplModalOpen, tplsLoading, tplsApproved, tplSel: tplSelected,
  tplVarNums, tplVars, tplVarMapping, tplImgUrl, tplImgErr, tplSending, tplTime,
  tplHasImg, tplHeaderTxt, tplFooterTxt, tplButtons, tplPreviewHtml,
  tplSendBlocked, tplSendBlockedReason,
  openTplModal, closeTplModal, selectTpl, setTplVar, sendTpl: sendTplToContact, mappedLabel,
} = useWhatsappTemplates({
  getContactPhone: () => props.win.conv?.contact?.phone,
  isWindowClosed:  () => isWindowClosed.value,
  getContact:      () => props.win.conv?.contact,
})

/* ── State ── */
// Singleton de módulo (useMessageCache.ts) — compartilhado com ConvDrawer.vue,
// FocoView.vue e MobileView.vue, pra mesma conversa aberta em mais de um lugar
// não buscar o histórico 2x. `msgs` continua se comportando como um ref comum
// (get/set) pro resto do arquivo — só a leitura/escrita interna aponta pro
// cache compartilhado por convId em vez de um array isolado desta instância.
const { msgCache } = useMessageCache()
const msgs = computed<ChatMessage[]>({
  get: () => msgCache.value[props.win.conv.id] ?? [],
  set: (val) => { msgCache.value = { ...msgCache.value, [props.win.conv.id]: val } },
})
const loadingMsgs = ref(false)
const loadingMore = ref(false)
const noMoreMsgs  = ref(false)
const draft       = ref('')
const attachFiles = ref<File[]>([])
const notaInterna = ref(false)
const msgsEl      = ref<HTMLElement | null>(null)
const taEl        = ref<HTMLTextAreaElement | null>(null)
const fileInputEl = ref<HTMLInputElement | null>(null)

const allLabels      = ref<LabelItem[]>([])
const labelsOpen     = ref(false)
const updatingLabels = ref(false)
const convLabels     = ref<string[]>([...props.win.conv.labels])

const {
  audioState, toggleAudio, seekAudio, audioProgress, fmtTime, disposeAudioEls,
  recording, recordingTime, recordedBlob, recordedUrl, waveformBars,
  startRecording, stopRecording, cancelRecording, sendRecordedAudio, fmtRecordingTime: fmtRecTime,
} = useAudioRecorder({
  barCount: 22,
  onSend: async (file) => { attachFiles.value = [file]; await sendMsg() },
})

let _pollTimer: ReturnType<typeof setInterval> | null = null
let _nowTimer:  ReturnType<typeof setInterval> | null = null

/* ── Status change ── */
const statusMenuOpen = ref(false)
const snoozeMode     = ref(false)
const snoozeH        = ref(1)
const snoozeM        = ref(0)
const statusLoading  = ref(false)
const nowSec         = ref(Math.floor(Date.now() / 1000))

/* ── Computed ── */
const { getProfileForFluxo: getFcwSLAProfile } = useSLA()

const fcwDocument = computed(() => {
  const conv = mw.value?.conv
  return conv ? conversationDocument(conv) : null
})

const slaBadge = computed<SLABadge | null>(() => {
  const conv = mw.value?.conv
  if (!conv || (conv.status !== 'open' && conv.status !== 'pending')) return null
  const profile = getFcwSLAProfile(conv.fluxo_id)
  if (!profile) return null
  const now = nowSec.value
  const candidates: { remaining: number; label: string; status: 'breached' | 'atRisk' }[] = []

  if (profile.resolutionTime > 0) {
    const deadline = conv.created_at + profile.resolutionTime * 60
    const remaining = deadline - now
    if (remaining <= 0) candidates.push({ remaining, label: 'Resolução', status: 'breached' })
    else if (profile.notifyBefore > 0 && remaining <= profile.notifyBefore * 60)
      candidates.push({ remaining, label: 'Resolução', status: 'atRisk' })
  }
  if (profile.firstResponseTime > 0 && conv.waiting_since > 0) {
    const deadline = conv.waiting_since + profile.firstResponseTime * 60
    const remaining = deadline - now
    if (remaining <= 0) candidates.push({ remaining, label: '1ª Resposta', status: 'breached' })
    else if (profile.notifyBefore > 0 && remaining <= profile.notifyBefore * 60)
      candidates.push({ remaining, label: '1ª Resposta', status: 'atRisk' })
  }
  if (!candidates.length) return null
  candidates.sort((a, b) => a.remaining - b.remaining)
  const worst = candidates[0]
  const abs = Math.abs(Math.floor(worst.remaining))
  const h = Math.floor(abs / 3600), m = Math.floor((abs % 3600) / 60), s = abs % 60
  const timeStr = worst.remaining <= 0
    ? `+${h > 0 ? h + 'h ' : ''}${m > 0 ? m + 'min' : s + 's'}`
    : `${h > 0 ? h + 'h ' : ''}${m > 0 ? m + 'min' : s + 's'}`
  return { label: worst.label, time: timeStr, status: worst.status }
})

const snoozeRemainingLabel = computed<string | null>(() => {
  const until = mw.value?.conv?.snoozed_until
  if (!until) return null
  const diff = until - nowSec.value
  if (diff <= 0) return null
  const h = Math.floor(diff / 3600)
  const m = Math.floor((diff % 3600) / 60)
  if (h > 0) return `${h}h ${m > 0 ? m + 'min' : ''}`
  if (m > 0) return `${m}min`
  return 'menos de 1min'
})

const processedMsgs = computed<ProcessedMsg[]>(() => {
  const list = msgs.value.filter(m => m.message_type <= 2 && (m.content || m.attachments?.length))
  return list.map((msg, i) => {
    const next = list[i + 1]
    return { ...msg, showAvatar: !next || next.message_type !== msg.message_type }
  })
})
const canSend       = computed(() => draft.value.trim().length > 0 || attachFiles.value.length > 0)
const currentLabels = computed(() => convLabels.value)
const isReadOnly    = computed(() => mw.value?.conv?.status === 'resolved')
const { isWindowClosed } = useMessageWindow(processedMsgs, nowSec)

// Notas internas exigem a janela aberta (mesmo composer da mensagem normal) — se a janela
// fechar enquanto o toggle está ativo, desativa pra não deixar o composer num estado inválido.
watch(isWindowClosed, (closed) => { if (closed) notaInterna.value = false })

/* ── Message search ── */
const {
  msgSearchOpen, msgSearchQuery, msgSearchActive, msgSearchLoading, msgCurrentIdx, msgSearchInputEl,
  msgMatchIds, getSig, highlightMsgHtml,
  openMsgSearch, closeMsgSearch, doMsgSearch, goNextMsg, goPrevMsg,
} = useMessageSearch({
  processedMsgs,
  msgsEl,
  messageSignature: () => authUser.value?.message_signature || '',
  loadMoreMsgs,
  noMoreMsgs,
})

/* ── Lifecycle ── */
// Mensagens em tempo real (Fase 5 do plano — docs/planos/PLANO-REALTIME-ACTIONCABLE.md):
// aplica a mensagem do próprio evento direto em msgs.value (onRealtimeMsg,
// sem refetch) na hora que chega message.created/updated pra esta conversa,
// em vez de esperar o próximo tick do poll de 8s abaixo — que continua
// existindo do mesmo jeito, como rede de segurança.
const msgRealtimeUnsub = onConversationMessage(props.win.conv.id, message => onRealtimeMsg(message))

onUnmounted(() => {
  if (_pollTimer) clearInterval(_pollTimer)
  if (_nowTimer)  clearInterval(_nowTimer)
  msgRealtimeUnsub()
  disposeAudioEls()
  cancelRecording()
  document.removeEventListener('click', onLblDocClick)
  document.removeEventListener('click', onStatusDocClick)
  document.removeEventListener('click', onTeamDocClick)
  pipWin?.document.removeEventListener('click', onLblDocClick)
  pipWin?.document.removeEventListener('click', onStatusDocClick)
  pipWin?.document.removeEventListener('click', onTeamDocClick)
  pipWin?.close()
})

// Se a conversa já está em msgCache (aberta antes nesta sessão, em
// ConvDrawer/FocoView/MobileView ou noutra janela flutuante), abre sem
// spinner — mesma lógica da Fase 1 de ConvDrawer.vue::openChat(). fetchMsgs
// só força scroll pro fim sozinho quando NÃO é silencioso; força aqui
// explicitamente pra cobrir os dois casos sem depender dessa heurística.
fetchMsgs(!!msgs.value.length).then(async () => { await nextTick(); scrollBottom() })
fetchAllLabels()
if (!isReadOnly.value) {
  _pollTimer = setInterval(() => fetchMsgs(true), 8000)
}
_nowTimer  = setInterval(() => { nowSec.value = Math.floor(Date.now() / 1000) }, 30_000)

/* ── Window actions ── */
function onWinClick() { bringToFront(props.win.uid) }

function toggleMinimize() { mw.value.minimized = !mw.value.minimized }

/* ── Pop-out (Document Picture-in-Picture) ──
   Move a janela pra fora do navegador, numa janela nativa sempre-visível — só existe em
   Chromium (Chrome/Edge). Enquanto pop-ada, arrastar/redimensionar ficam a cargo do próprio SO. */
const pipSupported = typeof window !== 'undefined' && 'documentPictureInPicture' in window
const isPipped = ref(false)
let pipWin: Window | null = null

function activeDocument(): Document { return (isPipped.value && pipWin) ? pipWin.document : document }

function closeAllMenus() {
  statusMenuOpen.value = false
  snoozeMode.value = false
  labelsOpen.value = false
  priorityMenuOpen.value = false
  agentMenuOpen.value = false
  teamMenuOpen.value = false
}

async function popOut() {
  if (!pipSupported || isPipped.value) return
  try {
    const dpip = (window as any).documentPictureInPicture
    // A janela flutuante na página costuma estar pequena (380x530, default de
    // useFloatChats.ts) — pop-ar nesse tamanho fica espremido. Abre já num
    // tamanho confortável, respeitando o espaço disponível na tela.
    const width  = Math.min(Math.max(Math.round(mw.value.w), 480), window.screen.availWidth - 40)
    const height = Math.min(Math.max(Math.round(mw.value.h), 680), window.screen.availHeight - 80)
    const win: Window = await dpip.requestWindow({ width, height })
    closeAllMenus() // limpa listeners de click-outside presos no document atual antes de trocar
    pipWin = win
    document.querySelectorAll('link[rel="stylesheet"], style').forEach(node => {
      win.document.head.appendChild(node.cloneNode(true))
    })
    // .fcw--pipped usa height:100% pra preencher a janela e deixar o header/
    // footer fixos com só as mensagens rolando (.fcw-msgs já é flex:1 +
    // overflow-y:auto) — mas isso só funciona com html/body com altura real,
    // senão o 100% não tem referência e a página inteira rola junto.
    win.document.documentElement.style.height = '100%'
    win.document.body.style.height = '100%'
    win.document.body.style.margin = '0'
    win.document.body.style.overflow = 'hidden'
    win.document.title = `${mw.value.conv.contact.name} · #${mw.value.conv.id}`
    isPipped.value = true
    teleportTarget.value = win.document.body
    win.addEventListener('pagehide', popIn, { once: true })
  } catch { /* usuário cancelou o pop-out ou API indisponível */ }
}

function popIn() {
  closeAllMenus()
  isPipped.value = false
  teleportTarget.value = 'body'
  pipWin = null
}

const teleportTarget = ref<string | HTMLElement>('body')

/* ── Drag ── */
let _dragging = false, _dx = 0, _dy = 0

function startDrag(e: MouseEvent) {
  if (isPipped.value) return
  _dragging = true
  _dx = e.clientX - mw.value.x
  _dy = e.clientY - mw.value.y
  document.addEventListener('mousemove', doDrag)
  document.addEventListener('mouseup', stopDrag)
  document.body.style.userSelect = 'none'
}
function doDrag(e: MouseEvent) {
  if (!_dragging) return
  mw.value.x = Math.max(0, Math.min(window.innerWidth - 80, e.clientX - _dx))
  mw.value.y = Math.max(0, Math.min(window.innerHeight - 40, e.clientY - _dy))
}
function stopDrag() {
  _dragging = false
  document.removeEventListener('mousemove', doDrag)
  document.removeEventListener('mouseup', stopDrag)
  document.body.style.userSelect = ''
}

/* ── Resize ── */
let _resizing = false, _rDir = '', _rx0 = 0, _ry0 = 0, _rw0 = 0, _rh0 = 0, _rpx0 = 0
function startResize(dir: string) {
  if (isPipped.value) return
  _resizing = true; _rDir = dir
  _rx0 = 0; _ry0 = 0
  document.addEventListener('mousemove', doResize)
  document.addEventListener('mouseup', stopResize)
  document.body.style.userSelect = 'none'
  document.body.style.cursor = dir === 'se' ? 'se-resize' : dir === 's' ? 's-resize' : dir === 'e' ? 'e-resize' : 'w-resize'
}

function doResize(e: MouseEvent) {
  if (!_resizing) return
  if (!_rx0) { _rx0 = e.clientX; _ry0 = e.clientY; _rw0 = mw.value.w; _rh0 = mw.value.h; _rpx0 = mw.value.x; return }
  const dx = e.clientX - _rx0, dy = e.clientY - _ry0
  if (_rDir === 'se' || _rDir === 'e') mw.value.w = Math.max(MIN_W, Math.min(MAX_W, _rw0 + dx))
  if (_rDir === 'se' || _rDir === 's') mw.value.h = Math.max(MIN_H, Math.min(MAX_H, _rh0 + dy))
  if (_rDir === 'w') {
    const nw = Math.max(MIN_W, Math.min(MAX_W, _rw0 - dx))
    mw.value.x = _rpx0 + (_rw0 - nw)
    mw.value.w = nw
  }
}
function stopResize() {
  _resizing = false
  document.removeEventListener('mousemove', doResize)
  document.removeEventListener('mouseup', stopResize)
  document.body.style.userSelect = ''
  document.body.style.cursor = ''
}

/* ── Messages ── */
// Merge por id (não substitui o array inteiro): uma atualização silenciosa
// (poll de 8s/evento realtime) só traz o lote recente da API — sobrescrever
// msgs.value com isso descartava o histórico já carregado via loadMoreMsgs e
// resetava a posição de quem tava lendo mensagens antigas. Ordena de novo
// por segurança (created_at), já que o merge não garante ordem.
function mergeMsgs(existing: ChatMessage[], incoming: ChatMessage[]): ChatMessage[] {
  const byId = new Map(existing.map(m => [m.id, m]))
  incoming.forEach(m => byId.set(m.id, m))
  return [...byId.values()].sort((a, b) => a.created_at - b.created_at)
}

// "Perto do fim" = auto-scroll é esperado (chat normal); acima disso, quem
// tá lendo histórico não pode ser puxado pro fim por uma atualização em segundo plano.
function isNearBottom(): boolean {
  const el = msgsEl.value
  if (!el) return true
  return el.scrollHeight - el.scrollTop - el.clientHeight < 120
}

async function fetchMsgs(silent = true) {
  if (!silent) loadingMsgs.value = true
  noMoreMsgs.value = false
  const wasNearBottom = isNearBottom()
  try {
    const messages = await fetchMessages(props.win.conv.id)
    if (messages !== null) {
      // Toca o som só quando já havia mensagens carregadas (evita disparar pra
      // cada mensagem do histórico na primeira abertura) e a nova é do contato
      // (message_type 0 = incoming, 1 = outgoing, 2 = atividade).
      if (msgs.value.length) {
        const prevIds = new Set(msgs.value.map(m => m.id))
        if (messages.some(m => m.message_type === 0 && !prevIds.has(m.id))) playNotificationSound()
      }
      msgs.value = silent && msgs.value.length ? mergeMsgs(msgs.value, messages) : messages
    }
  } catch { /* silencioso */ } finally {
    loadingMsgs.value = false
    if (!silent || wasNearBottom) { await nextTick(); scrollBottom() }
  }
}

// Evento realtime (message.created/updated desta conversa) — usa a mensagem
// que já vem no próprio evento (ver useChatwootMessageRealtime.ts) e faz
// merge direto em msgs.value, sem golpe de rede. O poll de 8s continua
// existindo como rede de segurança (via fetchMsgs acima, já não-destrutivo).
function onRealtimeMsg(message: ChatMessage) {
  if (!msgs.value.length) { fetchMsgs(true); return } // sem cache ainda (raro) — cai pro fetch normal
  const isNewIncoming = message.message_type === 0 && !msgs.value.some(m => m.id === message.id)
  const wasNearBottom = isNearBottom()
  msgs.value = mergeMsgs(msgs.value, [message])
  if (isNewIncoming) playNotificationSound()
  if (wasNearBottom) nextTick(() => scrollBottom())
}

async function loadMoreMsgs() {
  if (loadingMore.value || noMoreMsgs.value || !msgs.value.length) return
  loadingMore.value = true
  const prevHeight = msgsEl.value?.scrollHeight ?? 0
  try {
    const result = await fetchOlderMessages(props.win.conv.id, msgs.value)
    if (result.noMore) { noMoreMsgs.value = true; return }
    if (result.messages === msgs.value) return
    msgs.value = result.messages
    await nextTick()
    if (msgsEl.value) msgsEl.value.scrollTop = msgsEl.value.scrollHeight - prevHeight
  } catch { /* silencioso */ } finally {
    loadingMore.value = false
  }
}

function onMsgsScroll() {
  if (msgsEl.value && msgsEl.value.scrollTop < 60) loadMoreMsgs()
}

const { sending, sendMsg } = useMessageSender({
  getConvId: () => props.win.conv.id,
  getToken: () => authUser.value?.access_token || '',
  getContactPhone: () => props.win.conv?.contact?.phone,
  getSig,
  draft,
  files: attachFiles,
  isPrivate: notaInterna,
  fileInputEl,
  taEl,
  scrollBottom,
  getAssigneeId: () => mw.value.conv.assignee?.id ?? null,
  getMyAgentId: () => authUser.value?.id ?? 0,
  getLabels: () => convLabels.value,
  getStatus: () => mw.value.conv.status,
  onMessageCreated: (msg) => { msgs.value = [...msgs.value, msg] },
  onLabelsChanged: (_convId, labels) => { convLabels.value = labels },
  onAutoAssigned: (_convId, agentId) => {
    const me = authUser.value
    if (!me) return
    mw.value.conv = {
      ...mw.value.conv,
      assignee: { id: agentId, name: me.name, email: me.email, role: 'agent', thumbnail: me.avatar_url, availability: 'online' },
    }
  },
  onStatusChanged: (convId, status) => {
    mw.value.conv = { ...mw.value.conv, status }
    const idx = conversations.value.findIndex(c => c.id === convId)
    if (idx !== -1) conversations.value[idx] = { ...conversations.value[idx], status }
  },
})

function scrollBottom() { if (msgsEl.value) msgsEl.value.scrollTop = msgsEl.value.scrollHeight }
function growTa() {
  const el = taEl.value; if (!el) return
  el.style.height = 'auto'
  el.style.height = Math.min(el.scrollHeight, 100) + 'px'
}

function insertEmoji(em: string) {
  const el = taEl.value
  if (!el) { draft.value += em; return }
  const start = el.selectionStart ?? draft.value.length
  const end   = el.selectionEnd   ?? draft.value.length
  draft.value = draft.value.slice(0, start) + em + draft.value.slice(end)
  nextTick(() => {
    el.selectionStart = el.selectionEnd = start + em.length
    el.focus()
    growTa()
  })
}
function onFilePick(e: Event) {
  const input = e.target as HTMLInputElement
  if (input.files) { attachFiles.value.push(...Array.from(input.files)); input.value = '' }
}

/* ── Labels ── */
async function fetchAllLabels() {
  if (allLabels.value.length) return
  try {
    allLabels.value = await fetchAccountLabels(authUser.value?.access_token || '')
  } catch { /* silencioso */ }
}

async function toggleLabel(label: string) {
  if (updatingLabels.value) return
  const current = [...convLabels.value]
  const next = current.includes(label) ? current.filter(l => l !== label) : [...current, label]
  updatingLabels.value = true
  try {
    const result = await setConversationLabels(props.win.conv.id, authUser.value?.access_token || '', next)
    if (result) convLabels.value = result
  } catch { /* silencioso */ } finally {
    updatingLabels.value = false
  }
}

function onLblDocClick(e: MouseEvent) {
  const el = activeDocument().querySelector(`.fcw-lbl-picker`)
  if (el && !el.contains(e.target as Node)) labelsOpen.value = false
}
watch(labelsOpen, open => {
  if (open) setTimeout(() => activeDocument().addEventListener('click', onLblDocClick), 0)
  else activeDocument().removeEventListener('click', onLblDocClick)
})

/* ── Status change ── */
function convStatusLabel(s: string): string {
  return ({ open: 'Aberto', resolved: 'Resolvido', pending: 'Pendente', snoozed: 'Adiado' } as Record<string, string>)[s] ?? 'Aberto'
}

function onStatusDocClick() {
  statusMenuOpen.value = false
  snoozeMode.value = false
}
watch(statusMenuOpen, open => {
  if (open) setTimeout(() => activeDocument().addEventListener('click', onStatusDocClick), 0)
  else activeDocument().removeEventListener('click', onStatusDocClick)
})

async function doChangeStatus(status: string, snoozedUntil: number | null = null) {
  if (statusLoading.value) return
  if (status === 'resolved') {
    statusMenuOpen.value = false
    if (!(await confirmResolveConversation())) return
  }
  statusLoading.value = true
  statusMenuOpen.value = false
  snoozeMode.value = false
  try {
    let newStatus: string | null
    if (status === 'snoozed') {
      const result = await snoozeConversation(props.win.conv.id, authUser.value?.access_token || '', snoozedUntil)
      newStatus = result.status
    } else if (status === 'resolved') {
      const conv = props.win.conv
      const context: MacroActionContext = {
        contactPhone:       conv?.contact?.phone ?? null,
        contactName:        conv?.contact?.name  ?? null,
        contactEmail:       null,
        teamId:             conv?.team?.id   ?? null,
        teamName:           conv?.team?.name ?? null,
        conversationStatus: conv?.status ?? null,
        contactId:          conv?.contact?.id ?? null,
        assigneeId:         conv?.assignee?.id ?? null,
        assigneeName:       conv?.assignee?.name ?? null,
        labels:             conv?.labels ?? [],
        accountId:          authUser.value?.account_id ?? null,
        executedById:       authUser.value?.id ?? null,
        executedByName:     authUser.value?.name ?? null,
      }
      const outcome = await resolveConversationSmart(props.win.conv.id, authUser.value?.access_token || '', context)
      if (!outcome.ok) return
      newStatus = outcome.status ?? 'resolved'
    } else {
      newStatus = await toggleConversationStatus(props.win.conv.id, authUser.value?.access_token || '', status)
      if (newStatus === null) return
    }
    mw.value.conv = { ...mw.value.conv, status: newStatus, snoozed_until: snoozedUntil }
    // Sincroniza com a fila/dashboard por trás da janela flutuante, sem esperar o próximo polling
    const idx = conversations.value.findIndex(c => c.id === props.win.conv.id)
    if (idx !== -1) conversations.value[idx] = { ...conversations.value[idx], status: newStatus, snoozed_until: snoozedUntil }
  } catch { /* silencioso */ } finally {
    statusLoading.value = false
  }
}

function confirmSnooze() {
  const total = (snoozeH.value || 0) * 3600 + (snoozeM.value || 0) * 60
  const until = total > 0 ? Math.floor(Date.now() / 1000) + total : null
  doChangeStatus('snoozed', until)
}

/* ── Priority ── */
const priorityMenuOpen = ref(false)
const priorityLoading  = ref(false)

const currentPriority = computed<Priority | null>(() => {
  const p = mw.value?.conv?.priority
  return (p && p !== 'none') ? (p as Priority) : null
})

async function doTogglePriority(priority: Priority) {
  if (priorityLoading.value) return
  priorityMenuOpen.value = false
  priorityLoading.value = true
  const prevPriority = mw.value.conv.priority
  mw.value.conv = { ...mw.value.conv, priority: priority === 'none' ? null : priority }
  try {
    const res = await fetch(`${API}/conversations/${props.win.conv.id}/toggle_priority`, {
      method: 'POST',
      headers: { ...apiHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ priority }),
    })
    if (!res.ok) {
      mw.value.conv = { ...mw.value.conv, priority: prevPriority }
    }
  } catch {
    mw.value.conv = { ...mw.value.conv, priority: prevPriority }
  } finally {
    priorityLoading.value = false
  }
}

function onPriorityDocClick() { priorityMenuOpen.value = false }
watch(priorityMenuOpen, open => {
  if (open) activeDocument().addEventListener('click', onPriorityDocClick)
  else activeDocument().removeEventListener('click', onPriorityDocClick)
})

/* ── Atribuição de agente ── */
const agentMenuOpen  = ref(false)
const agentLoading   = ref(false)
const teamAgents     = ref<AgentItem[]>([])
const agentSearch    = ref('')
let   _agentsFetched = false

// Status (agent_status) pra bolinha no avatar da lista — mesma fonte usada em
// TeamMembersModal.vue, não o availability_status do Chatwoot (ver useAvailability.ts).
const agentStatusByUser = ref<Record<number, string>>({})

const filteredAgents = computed(() => {
  const q = agentSearch.value.toLowerCase().trim()
  return q ? teamAgents.value.filter(a => a.name.toLowerCase().includes(q)) : teamAgents.value
})

function agentStatusOf(userId: number): string {
  return agentStatusByUser.value[userId] ?? 'offline'
}

function availLabel(status: string): string {
  return { online: 'Online', busy: 'Ocupado', offline: 'Offline' }[status] ?? 'Offline'
}

// Traz todos os agentes da conta (não só os do time da conversa) — o supervisor
// pode precisar atribuir a qualquer agente, independente do time atual.
// Status de disponibilidade vem de allAgents (useDashboardEngine) — já mantido
// por loadData() a cada ciclo (login/Atualizar/fim do countdown); list_agent_status
// não é mais chamado à parte aqui (ver useDashboardEngine.loadData()).
async function fetchAgents() {
  if (agentLoading.value || _agentsFetched) return
  _agentsFetched = true
  agentLoading.value = true
  try {
    teamAgents.value = await listTeamMembersOrAgents(authUser.value?.access_token || '', null)
    agentStatusByUser.value = Object.fromEntries(
      allAgents.value.map(a => [a.id, a.availability_status])
    )
  } catch {
    _agentsFetched = false
  } finally {
    agentLoading.value = false
  }
}

async function doAssignAgent(agentId: number | null) {
  if (agentId && isFluxoGeral(mw.value.conv.fluxo_id)) {
    if (!(await confirmAssignDuringFluxoGeral())) return
  }
  agentMenuOpen.value = false
  agentSearch.value = ''
  const prev = mw.value.conv.assignee
  const agent = agentId ? teamAgents.value.find(a => a.id === agentId) : null
  mw.value.conv = {
    ...mw.value.conv,
    assignee: agent
      ? { id: agent.id, name: agent.name, email: '', role: 'agent', thumbnail: agent.thumbnail, availability: 'online' }
      : null,
  }
  try {
    const ok = await assignAgentViaSystem(props.win.conv.id, agentId)
    if (!ok) {
      mw.value.conv = { ...mw.value.conv, assignee: prev }
    } else if (agent && authUser.value) {
      logManualAssignment(props.win.conv.id, agent.id, agent.name, props.win.conv.contact.name, authUser.value.id, authUser.value.name)
    }
  } catch {
    mw.value.conv = { ...mw.value.conv, assignee: prev }
  }
}

function onAgentDocClick() { agentMenuOpen.value = false; agentSearch.value = '' }
watch(agentMenuOpen, open => {
  if (open) { fetchAgents(); setTimeout(() => activeDocument().addEventListener('click', onAgentDocClick), 0) }
  else activeDocument().removeEventListener('click', onAgentDocClick)
})

/* ── Atribuição de time ── */
const teamMenuOpen  = ref(false)
const teamsLoading  = ref(false)
const teamsList     = ref<TeamItem[]>([])
const teamSearch    = ref('')
let   _teamsFetched = false

const filteredTeams = computed(() => {
  const allowed = allowedTeamIds()
  let list = allowed !== null ? teamsList.value.filter(t => allowed.includes(t.id)) : teamsList.value
  const q = teamSearch.value.toLowerCase().trim()
  return q ? list.filter(t => t.name.toLowerCase().includes(q)) : list
})

async function fetchTeams() {
  if (_teamsFetched) return
  teamsLoading.value = true
  try {
    teamsList.value = await listTeams(authUser.value?.access_token || '')
    _teamsFetched = true
  } catch { /* silencioso */ } finally {
    teamsLoading.value = false
  }
}

async function doAssignTeam(teamId: number | null) {
  teamMenuOpen.value = false
  teamSearch.value = ''
  const prevTeam = mw.value.conv.team
  const team = teamId ? teamsList.value.find(t => t.id === teamId) : null
  mw.value.conv = { ...mw.value.conv, team: team ? { id: team.id, name: team.name } : null }
  try {
    const ok = await assignTeam(props.win.conv.id, authUser.value?.access_token || '', teamId)
    if (!ok) mw.value.conv = { ...mw.value.conv, team: prevTeam }
  } catch {
    mw.value.conv = { ...mw.value.conv, team: prevTeam }
  }
}

function onTeamDocClick() { teamMenuOpen.value = false; teamSearch.value = '' }
watch(teamMenuOpen, open => {
  if (open) { fetchTeams(); setTimeout(() => activeDocument().addEventListener('click', onTeamDocClick), 0) }
  else activeDocument().removeEventListener('click', onTeamDocClick)
})

/* ── Helpers ── */
function senderName(msg: ChatMessage): string { return msg.sender?.name || msg.sender?.available_name || '?' }
function fmtTs(ts: number): string {
  const d = new Date(ts * 1000)
  return `${d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })} ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`
}

// ── Macro panel ───────────────────────────────────────────
const macroPanelOpen  = ref(false)
const macrosList      = ref<MacroItem[]>([])
const macrosLoading   = ref(false)
const macroSearch     = ref('')
const macroRunning    = ref(false)
const macroRunDone    = ref(false)
const macroRunningObj = ref<MacroItem | null>(null)
const macroStepResults = ref<{ label: string; ok: boolean; msg: string }[]>([])

const filteredMacros = computed(() => {
  const q          = macroSearch.value.trim().toLowerCase()
  const convTeamId = props.win.conv.team?.id ?? null
  const active     = macrosList.value.filter(m => {
    if (!m.is_active) return false
    if (!m.team_ids?.length) return true
    return convTeamId ? m.team_ids.includes(convTeamId) : true
  })
  return q ? active.filter(m => m.name.toLowerCase().includes(q)) : active
})

async function loadMacros(force = false) {
  if (macrosList.value.length && !force) return
  macrosLoading.value = true
  try {
    macrosList.value = await listMacros(authUser.value?.access_token || '')
  } catch { /* silently fail */ }
  finally { macrosLoading.value = false }
}

function toggleMacroPanel() {
  macroPanelOpen.value = !macroPanelOpen.value
  if (macroPanelOpen.value) {
    loadMacros()
    resetMacroRun()
  }
}

function resetMacroRun() {
  macroRunning.value    = false
  macroRunDone.value    = false
  macroRunningObj.value = null
  macroStepResults.value = []
}

/**
 * Contexto pro motor de macro. Sempre parte dos dados já carregados na janela;
 * se a macro tiver alguma ação de webhook, faz um GET da conversa pra ter
 * contact_email/team atualizados (o objeto local não carrega email de contato).
 */
async function fcwMacroContext(macro: MacroItem): Promise<MacroActionContext> {
  const conv = props.win.conv
  const base: MacroActionContext = {
    contactPhone:       conv?.contact?.phone ?? null,
    contactName:        conv?.contact?.name  ?? null,
    contactEmail:       null,
    teamId:             conv?.team?.id   ?? null,
    teamName:           conv?.team?.name ?? null,
    conversationStatus: conv?.status ?? null,
    contactId:          conv?.contact?.id ?? null,
    assigneeId:         conv?.assignee?.id ?? null,
    assigneeName:       conv?.assignee?.name ?? null,
    labels:             conv?.labels ?? [],
    accountId:          authUser.value?.account_id ?? null,
    macroId:            macro.id,
    macroName:          macro.name,
    executedById:       authUser.value?.id ?? null,
    executedByName:     authUser.value?.name ?? null,
  }
  const needsLiveContext = macro.actions.some(a => a.action_name === 'send_webhook_event' || a.action_name === 'send_webhook_event_form')
  if (!needsLiveContext) return base
  try {
    const res = await fetch(apiUrl(`/conversations/${conv.id}`), { headers: apiHeaders() })
    if (!res.ok) return base
    const data = await res.json()
    return {
      ...base,
      contactPhone: data?.meta?.sender?.phone_number ?? base.contactPhone,
      contactName:  data?.meta?.sender?.name ?? base.contactName,
      contactEmail: data?.meta?.sender?.email ?? null,
      teamId:       data?.meta?.team?.id ?? base.teamId,
      teamName:     data?.meta?.team?.name ?? base.teamName,
      inboxId:      data?.inbox_id ?? null,
      inboxName:    data?.channel ?? null,
      rawConversation: data,
    }
  } catch {
    return base
  }
}

async function runMacroInChat(macro: MacroItem) {
  // Collect form values for send_webhook_event_form actions before executing
  const formActions = macro.actions
    .map((a, idx) => ({ action: a, idx }))
    .filter(({ action }) => action.action_name === 'send_webhook_event_form')

  let formValuesByIdx: Record<number, Record<string, string>> = {}

  if (formActions.length) {
    let html = '<div style="text-align:left">'
    for (const { action, idx } of formActions) {
      const cfg    = action.action_params?.[0] ?? {}
      const fields: Array<{ key: string; label: string }> = Array.isArray(cfg.fields) ? cfg.fields : []
      if (!fields.length) continue
      if (formActions.length > 1) {
        html += `<div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.6px;color:#6b7280;margin:10px 0 6px">Webhook ${idx + 1}</div>`
      }
      for (const field of fields) {
        html += `<div style="margin-bottom:10px">
          <label style="display:block;font-size:12px;font-weight:600;color:#374151;margin-bottom:3px">${field.label || field.key}</label>
          <input id="wff_${idx}_${field.key}" data-idx="${idx}" data-key="${field.key}"
            style="width:100%;padding:7px 10px;border:1px solid #d1d5db;border-radius:6px;font-size:13px;box-sizing:border-box;font-family:inherit"
            placeholder="${field.label || field.key}" />
        </div>`
      }
    }
    html += '</div>'

    const result = await Swal.fire({
      title: 'Preencha os campos',
      html,
      showCancelButton: true,
      confirmButtonText: 'Executar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#2563eb',
      cancelButtonColor: '#6b7280',
      focusConfirm: false,
      preConfirm: () => {
        const inputs = Swal.getHtmlContainer()?.querySelectorAll('input[data-idx]') ?? []
        const values: Record<number, Record<string, string>> = {}
        inputs.forEach((el: any) => {
          const i   = Number(el.dataset.idx)
          const key = String(el.dataset.key)
          if (!values[i]) values[i] = {}
          values[i][key] = el.value
        })
        return values
      },
    })

    if (!result.isConfirmed) return
    formValuesByIdx = (result.value as Record<number, Record<string, string>>) ?? {}
  }

  macroRunningObj.value  = macro
  macroStepResults.value = []
  macroRunDone.value     = false
  macroRunning.value     = true
  const convId = props.win.conv.id
  const context = await fcwMacroContext(macro)
  for (const [idx, action] of macro.actions.entries()) {
    const formVals = action.action_name === 'send_webhook_event_form'
      ? (formValuesByIdx[idx] ?? {})
      : undefined
    macroStepResults.value.push(
      await runMacroAction(action, convId, authUser.value?.access_token || '', context, formVals)
    )
  }
  macroRunning.value = false
  macroRunDone.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: teleportTarget.value }, [
      _createElementVNode("div", {
        class: _normalizeClass(["fcw", { 'fcw--minimized': __props.win.minimized, 'fcw--pipped': isPipped.value }]),
        style: _normalizeStyle(isPipped.value
        ? { width: '100%', height: '100%' }
        : { left: __props.win.x+'px', top: __props.win.y+'px', width: __props.win.w+'px', zIndex: __props.win.z,
            height: __props.win.minimized ? 'auto' : __props.win.h+'px' }),
        onMousedownCapture: onWinClick
      }, [
        _createElementVNode("div", {
          class: "fcw-head",
          onMousedown: _withModifiers(startDrag, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "fcw-av",
              style: _normalizeStyle({ background: _unref(avatarColor)(__props.win.conv.contact.name) })
            }, [
              (__props.win.conv.contact.thumbnail)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: __props.win.conv.contact.thumbnail,
                    onError: _cache[0] || (_cache[0] = (e) => (e.target as HTMLImageElement).style.display='none')
                  }, null, 40, _hoisted_2))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(initials)(__props.win.conv.contact.name)), 1))
            ], 4),
            (mw.value.conv.status === 'snoozed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[65] || (_cache[65] = [
                  _createElementVNode("svg", {
                    width: "7",
                    height: "7",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "10"
                    }),
                    _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.win.conv.contact.name), 1),
            (fcwDocument.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(fcwDocument.value.label) + ": " + _toDisplayString(fcwDocument.value.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              (__props.win.conv.team)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(__props.win.conv.team.name) + " · ", 1))
                : _createCommentVNode("", true),
              _createTextVNode("#" + _toDisplayString(__props.win.conv.id) + " ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(['fcw-status-lbl', mw.value.conv.status])
              }, _toDisplayString(convStatusLabel(mw.value.conv.status)), 3),
              (slaBadge.value)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(['fcw-sla-badge', slaBadge.value.status])
                  }, [
                    _cache[66] || (_cache[66] = _createElementVNode("svg", {
                      width: "9",
                      height: "9",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "10"
                      }),
                      _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                    ], -1)),
                    _createElementVNode("strong", null, _toDisplayString(slaBadge.value.time), 1),
                    _createElementVNode("span", null, _toDisplayString(slaBadge.value.label), 1)
                  ], 2))
                : _createCommentVNode("", true),
              (mw.value.conv.assignee)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _cache[67] || (_cache[67] = _createElementVNode("svg", {
                      width: "9",
                      height: "9",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "7",
                        r: "4"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(mw.value.conv.assignee.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", {
            class: "fcw-head-btns",
            onMousedown: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", {
              class: "fcw-status-wrap",
              onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("button", {
                class: "fcw-btn",
                title: `Status: ${convStatusLabel(mw.value.conv.status)}`,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (!isReadOnly.value && (statusMenuOpen.value = !statusMenuOpen.value, snoozeMode.value = false)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["fcw-s-dot", mw.value.conv.status])
                }, null, 2)
              ], 8, _hoisted_11),
              (statusMenuOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (!snoozeMode.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (mw.value.conv.status !== 'open')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "fcw-sopt",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (doChangeStatus('open')))
                              }, [...(_cache[68] || (_cache[68] = [
                                _createElementVNode("span", { class: "fcw-s-dot open" }, null, -1),
                                _createTextVNode(" Abrir ", -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (mw.value.conv.status !== 'resolved')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "fcw-sopt",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (doChangeStatus('resolved')))
                              }, [...(_cache[69] || (_cache[69] = [
                                _createElementVNode("span", { class: "fcw-s-dot resolved" }, null, -1),
                                _createTextVNode(" Resolver ", -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          (mw.value.conv.status !== 'pending')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "fcw-sopt",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (doChangeStatus('pending')))
                              }, [...(_cache[70] || (_cache[70] = [
                                _createElementVNode("span", { class: "fcw-s-dot pending" }, null, -1),
                                _createTextVNode(" Pendente ", -1)
                              ]))]))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "fcw-sopt",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (snoozeMode.value = true))
                          }, [...(_cache[71] || (_cache[71] = [
                            _createElementVNode("span", { class: "fcw-s-dot snoozed" }, null, -1),
                            _createTextVNode(" Adiar… ", -1)
                          ]))])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _cache[74] || (_cache[74] = _createElementVNode("div", { class: "fcw-snz-title" }, "Adiar por quanto tempo?", -1)),
                          _createElementVNode("div", _hoisted_14, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((snoozeH).value = $event)),
                              min: "0",
                              max: "99",
                              class: "fcw-snz-inp"
                            }, null, 512), [
                              [
                                _vModelText,
                                snoozeH.value,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _cache[72] || (_cache[72] = _createElementVNode("span", { class: "fcw-snz-lbl" }, "h", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((snoozeM).value = $event)),
                              min: "0",
                              max: "59",
                              class: "fcw-snz-inp"
                            }, null, 512), [
                              [
                                _vModelText,
                                snoozeM.value,
                                void 0,
                                { number: true }
                              ]
                            ]),
                            _cache[73] || (_cache[73] = _createElementVNode("span", { class: "fcw-snz-lbl" }, "min", -1))
                          ]),
                          _cache[75] || (_cache[75] = _createElementVNode("div", { class: "fcw-snz-hint" }, "0h 0min = até próxima resposta", -1)),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("button", {
                              class: "fcw-snz-cancel",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (snoozeMode.value = false))
                            }, "Cancelar"),
                            _createElementVNode("button", {
                              class: "fcw-snz-confirm",
                              onClick: confirmSnooze,
                              disabled: statusLoading.value
                            }, "Confirmar", 8, _hoisted_16)
                          ])
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["fcw-btn", { 'fcw-btn--active': macroPanelOpen.value }]),
              onClick: toggleMacroPanel,
              title: "Macros"
            }, [...(_cache[76] || (_cache[76] = [
              _createElementVNode("svg", {
                width: "11",
                height: "11",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" })
              ], -1)
            ]))], 2),
            _createElementVNode("button", {
              class: "fcw-btn",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(openMsgSearch) && _unref(openMsgSearch)(...args))),
              title: "Buscar nas mensagens"
            }, [...(_cache[77] || (_cache[77] = [
              _createElementVNode("svg", {
                width: "11",
                height: "11",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("circle", {
                  cx: "11",
                  cy: "11",
                  r: "8"
                }),
                _createElementVNode("line", {
                  x1: "21",
                  y1: "21",
                  x2: "16.65",
                  y2: "16.65"
                })
              ], -1)
            ]))]),
            (_unref(pipSupported) && !isPipped.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "fcw-btn",
                  onClick: popOut,
                  title: "Abrir em janela flutuante do sistema (fora do navegador)"
                }, [...(_cache[78] || (_cache[78] = [
                  _createElementVNode("svg", {
                    width: "11",
                    height: "11",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
                    _createElementVNode("polyline", { points: "15 3 21 3 21 9" }),
                    _createElementVNode("line", {
                      x1: "10",
                      y1: "14",
                      x2: "21",
                      y2: "3"
                    })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (isPipped.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "fcw-btn",
                  onClick: _cache[11] || (_cache[11] = () => _unref(pipWin)?.close()),
                  title: "Voltar pra página"
                }, [...(_cache[79] || (_cache[79] = [
                  _createElementVNode("svg", {
                    width: "11",
                    height: "11",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("path", { d: "M9 21H5a2 2 0 0 1-2-2V9m0 0l6 6m-6-6h6V3" })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (!isPipped.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "fcw-btn",
                  onClick: toggleMinimize,
                  title: __props.win.minimized ? 'Restaurar' : 'Minimizar'
                }, [
                  (__props.win.minimized)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_18, [...(_cache[80] || (_cache[80] = [
                        _createElementVNode("polyline", { points: "18 15 12 9 6 15" }, null, -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[81] || (_cache[81] = [
                        _createElementVNode("line", {
                          x1: "5",
                          y1: "12",
                          x2: "19",
                          y2: "12"
                        }, null, -1)
                      ]))]))
                ], 8, _hoisted_17))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "fcw-btn fcw-btn-close",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close'))),
              title: "Fechar"
            }, [...(_cache[82] || (_cache[82] = [
              _createElementVNode("svg", {
                width: "11",
                height: "11",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("line", {
                  x1: "18",
                  y1: "6",
                  x2: "6",
                  y2: "18"
                }),
                _createElementVNode("line", {
                  x1: "6",
                  y1: "6",
                  x2: "18",
                  y2: "18"
                })
              ], -1)
            ]))])
          ], 32)
        ], 32),
        (!__props.win.minimized)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_20, [
                (!isReadOnly.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "fcw-agent-wrap",
                      onClick: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (mw.value.conv.assignee)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "fcw-agent-sel",
                            onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (agentMenuOpen.value = !agentMenuOpen.value), ["stop"])),
                            title: "Mudar agente"
                          }, [
                            _cache[83] || (_cache[83] = _createElementVNode("svg", {
                              width: "7",
                              height: "7",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "7",
                                r: "4"
                              })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(mw.value.conv.assignee.name), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "fcw-lbl-add",
                            onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (agentMenuOpen.value = !agentMenuOpen.value), ["stop"]))
                          }, [...(_cache[84] || (_cache[84] = [
                            _createElementVNode("svg", {
                              width: "7",
                              height: "7",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" }),
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "7",
                                r: "4"
                              })
                            ], -1),
                            _createTextVNode(" agente ", -1)
                          ]))])),
                      (agentMenuOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((agentSearch).value = $event)),
                                class: "fcw-agent-search",
                                placeholder: "Buscar agente…",
                                onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"])),
                                onKeydown: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                              }, null, 544), [
                                [_vModelText, agentSearch.value]
                              ])
                            ]),
                            (agentLoading.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[85] || (_cache[85] = [
                                  _createElementVNode("span", {
                                    class: "fcw-spinner",
                                    style: {"width":"14px","height":"14px","border-width":"2px"}
                                  }, null, -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["fcw-agent-opt", { active: !mw.value.conv.assignee }]),
                                    onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (doAssignAgent(null)), ["stop"]))
                                  }, [
                                    _cache[87] || (_cache[87] = _createElementVNode("div", {
                                      class: "fcw-agent-av",
                                      style: {"background":"var(--ink-10)","color":"var(--ink-50)","font-size":"10px"}
                                    }, "—", -1)),
                                    _cache[88] || (_cache[88] = _createTextVNode(" Sem agente ", -1)),
                                    (!mw.value.conv.assignee)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_25, [...(_cache[86] || (_cache[86] = [
                                          _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                        ]))]))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredAgents.value, (a) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: a.id,
                                      class: _normalizeClass(["fcw-agent-opt", { active: mw.value.conv.assignee?.id === a.id }]),
                                      onClick: _withModifiers(($event: any) => (doAssignAgent(a.id)), ["stop"])
                                    }, [
                                      _createElementVNode("div", {
                                        class: "fcw-agent-av-wrap",
                                        title: availLabel(agentStatusOf(a.id))
                                      }, [
                                        _createElementVNode("div", {
                                          class: "fcw-agent-av",
                                          style: _normalizeStyle({ background: _unref(avatarColor)(a.name), overflow:'hidden' })
                                        }, [
                                          (a.thumbnail)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: a.thumbnail,
                                                alt: a.name,
                                                style: {"width":"100%","height":"100%","object-fit":"cover","border-radius":"50%","display":"block"},
                                                onError: _cache[20] || (_cache[20] = (e) => (e.target as HTMLImageElement).style.display='none')
                                              }, null, 40, _hoisted_28))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(initials)(a.name)), 1))
                                        ], 4),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["fcw-agent-status-dot", `fasd-${agentStatusOf(a.id)}`])
                                        }, null, 2)
                                      ], 8, _hoisted_27),
                                      _createTextVNode(" " + _toDisplayString(a.name) + " ", 1),
                                      (mw.value.conv.assignee?.id === a.id)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_30, [...(_cache[89] || (_cache[89] = [
                                            _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                          ]))]))
                                        : _createCommentVNode("", true)
                                    ], 10, _hoisted_26))
                                  }), 128))
                                ]))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!isReadOnly.value && canAssignTeam.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "fcw-agent-wrap",
                      onClick: _cache[28] || (_cache[28] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (mw.value.conv.team)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "fcw-agent-sel",
                            onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (teamMenuOpen.value = !teamMenuOpen.value), ["stop"])),
                            title: "Mudar time"
                          }, [
                            _cache[90] || (_cache[90] = _createElementVNode("svg", {
                              width: "7",
                              height: "7",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                              _createElementVNode("circle", {
                                cx: "9",
                                cy: "7",
                                r: "4"
                              }),
                              _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                              _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(mw.value.conv.team.name), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "fcw-lbl-add",
                            onClick: _cache[23] || (_cache[23] = _withModifiers(($event: any) => (teamMenuOpen.value = !teamMenuOpen.value), ["stop"]))
                          }, [...(_cache[91] || (_cache[91] = [
                            _createElementVNode("svg", {
                              width: "7",
                              height: "7",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                              _createElementVNode("circle", {
                                cx: "9",
                                cy: "7",
                                r: "4"
                              }),
                              _createElementVNode("path", { d: "M23 21v-2a4 4 0 0 0-3-3.87" }),
                              _createElementVNode("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
                            ], -1),
                            _createTextVNode(" time ", -1)
                          ]))])),
                      (teamMenuOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((teamSearch).value = $event)),
                                class: "fcw-agent-search",
                                placeholder: "Buscar time…",
                                onClick: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["stop"])),
                                onKeydown: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["stop"]))
                              }, null, 544), [
                                [_vModelText, teamSearch.value]
                              ])
                            ]),
                            (teamsLoading.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[92] || (_cache[92] = [
                                  _createElementVNode("span", {
                                    class: "fcw-spinner",
                                    style: {"width":"14px","height":"14px","border-width":"2px"}
                                  }, null, -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["fcw-agent-opt", { active: !mw.value.conv.team }]),
                                    onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (doAssignTeam(null)), ["stop"]))
                                  }, [
                                    _cache[94] || (_cache[94] = _createElementVNode("div", {
                                      class: "fcw-agent-av",
                                      style: {"background":"var(--ink-10)","color":"var(--ink-50)","font-size":"10px"}
                                    }, "—", -1)),
                                    _cache[95] || (_cache[95] = _createTextVNode(" Sem time ", -1)),
                                    (!mw.value.conv.team)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_35, [...(_cache[93] || (_cache[93] = [
                                          _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                        ]))]))
                                      : _createCommentVNode("", true)
                                  ], 2),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTeams.value, (t) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: t.id,
                                      class: _normalizeClass(["fcw-agent-opt", { active: mw.value.conv.team?.id === t.id }]),
                                      onClick: _withModifiers(($event: any) => (doAssignTeam(t.id)), ["stop"])
                                    }, [
                                      _createElementVNode("div", {
                                        class: "fcw-agent-av",
                                        style: _normalizeStyle({ background: _unref(avatarColor)(t.name) })
                                      }, _toDisplayString(_unref(initials)(t.name)), 5),
                                      _createTextVNode(" " + _toDisplayString(t.name) + " ", 1),
                                      (mw.value.conv.team?.id === t.id)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_37, [...(_cache[96] || (_cache[96] = [
                                            _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                          ]))]))
                                        : _createCommentVNode("", true)
                                    ], 10, _hoisted_36))
                                  }), 128))
                                ]))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!isReadOnly.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "fcw-priority-wrap",
                      onClick: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      (currentPriority.value)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "fcw-priority-tag",
                            style: _normalizeStyle({ background: _unref(PRIORITY_COLORS)[currentPriority.value] + '22', color: _unref(PRIORITY_COLORS)[currentPriority.value], borderColor: _unref(PRIORITY_COLORS)[currentPriority.value] + '55' }),
                            onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (priorityMenuOpen.value = !priorityMenuOpen.value), ["stop"])),
                            title: `Prioridade: ${_unref(PRIORITY_LABELS)[currentPriority.value]}`
                          }, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_39, [...(_cache[97] || (_cache[97] = [
                              _createElementVNode("path", { d: "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" }, null, -1)
                            ]))])),
                            _createTextVNode(" " + _toDisplayString(_unref(PRIORITY_LABELS)[currentPriority.value]) + " ", 1),
                            (priorityLoading.value)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40))
                              : _createCommentVNode("", true)
                          ], 12, _hoisted_38))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "fcw-lbl-add fcw-priority-add",
                            onClick: _cache[30] || (_cache[30] = _withModifiers(($event: any) => (priorityMenuOpen.value = !priorityMenuOpen.value), ["stop"])),
                            disabled: priorityLoading.value
                          }, [
                            (!priorityLoading.value)
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_42, [...(_cache[98] || (_cache[98] = [
                                  _createElementVNode("path", { d: "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" }, null, -1)
                                ]))]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_43)),
                            _cache[99] || (_cache[99] = _createTextVNode(" prioridade ", -1))
                          ], 8, _hoisted_41)),
                      (priorityMenuOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList((['urgent','high','medium','low','none'] as const), (p) => {
                              return _createElementVNode("button", {
                                key: p,
                                class: _normalizeClass(["fcw-priority-opt", { active: mw.value.conv.priority === p || (!mw.value.conv.priority && p === 'none') }]),
                                onClick: _withModifiers(($event: any) => (doTogglePriority(p)), ["stop"])
                              }, [
                                (p !== 'none')
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "fcw-priority-dot",
                                      style: _normalizeStyle({ background: _unref(PRIORITY_COLORS)[p] })
                                    }, null, 4))
                                  : (_openBlock(), _createElementBlock("svg", _hoisted_46, [...(_cache[100] || (_cache[100] = [
                                      _createElementVNode("line", {
                                        x1: "5",
                                        y1: "12",
                                        x2: "19",
                                        y2: "12"
                                      }, null, -1)
                                    ]))])),
                                _createTextVNode(" " + _toDisplayString(_unref(PRIORITY_LABELS)[p]) + " ", 1),
                                (mw.value.conv.priority === p || (!mw.value.conv.priority && p === 'none'))
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_47, [...(_cache[101] || (_cache[101] = [
                                      _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_45)
                            }), 64))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentLabels.value, (l) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: l,
                    class: "fcw-lbl"
                  }, [
                    _createTextVNode(_toDisplayString(l.replace(/_/g, ' ')) + " ", 1),
                    (!isReadOnly.value && !_unref(isLabelProtected)(l))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "fcw-lbl-x",
                          onClick: _withModifiers(($event: any) => (toggleLabel(l)), ["stop"]),
                          disabled: updatingLabels.value
                        }, "×", 8, _hoisted_48))
                      : (!isReadOnly.value)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_49, [...(_cache[102] || (_cache[102] = [
                            _createElementVNode("rect", {
                              x: "3",
                              y: "11",
                              width: "18",
                              height: "11",
                              rx: "2"
                            }, null, -1),
                            _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (!isReadOnly.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("button", {
                        class: "fcw-lbl-add",
                        onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (labelsOpen.value = !labelsOpen.value), ["stop"])),
                        disabled: updatingLabels.value
                      }, [...(_cache[103] || (_cache[103] = [
                        _createElementVNode("svg", {
                          width: "8",
                          height: "8",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "3.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("line", {
                            x1: "12",
                            y1: "5",
                            x2: "12",
                            y2: "19"
                          }),
                          _createElementVNode("line", {
                            x1: "5",
                            y1: "12",
                            x2: "19",
                            y2: "12"
                          })
                        ], -1),
                        _createTextVNode(" etiqueta ", -1)
                      ]))], 8, _hoisted_51),
                      (labelsOpen.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            (!allLabels.value.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [...(_cache[104] || (_cache[104] = [
                                  _createElementVNode("span", {
                                    class: "fcw-spinner",
                                    style: {"width":"12px","height":"12px","border-width":"2px"}
                                  }, null, -1)
                                ]))]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allLabels.value, (lbl) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: lbl.id,
                                class: _normalizeClass(["fcw-lbl-opt", { checked: currentLabels.value.includes(lbl.title) }]),
                                onClick: _withModifiers(($event: any) => ((currentLabels.value.includes(lbl.title) && _unref(isLabelProtected)(lbl.title)) || toggleLabel(lbl.title)), ["prevent"])
                              }, [
                                _createElementVNode("span", {
                                  class: "fcw-lbl-dot",
                                  style: _normalizeStyle({ background: lbl.color })
                                }, null, 4),
                                _createElementVNode("span", null, _toDisplayString(lbl.title.replace(/_/g, ' ')), 1),
                                (currentLabels.value.includes(lbl.title) && _unref(isLabelProtected)(lbl.title))
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_55, [...(_cache[105] || (_cache[105] = [
                                      _createElementVNode("rect", {
                                        x: "3",
                                        y: "11",
                                        width: "18",
                                        height: "11",
                                        rx: "2"
                                      }, null, -1),
                                      _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" }, null, -1)
                                    ]))]))
                                  : (currentLabels.value.includes(lbl.title))
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_56, [...(_cache[106] || (_cache[106] = [
                                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                              ], 10, _hoisted_54))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (mw.value.conv.status === 'snoozed')
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _cache[107] || (_cache[107] = _createElementVNode("svg", {
                      width: "12",
                      height: "12",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "10"
                      }),
                      _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                    ], -1)),
                    (snoozeRemainingLabel.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_58, "Adiado — " + _toDisplayString(snoozeRemainingLabel.value) + " restantes", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_59, "Adiado até próxima resposta do cliente"))
                  ]))
                : _createCommentVNode("", true),
              (_unref(msgSearchOpen))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "fcw-msg-search-bar",
                    onMousedown: _cache[39] || (_cache[39] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      ref_key: "msgSearchInputEl",
                      ref: msgSearchInputEl,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_isRef(msgSearchQuery) ? (msgSearchQuery).value = $event : null)),
                      class: "fcw-msg-search-input",
                      placeholder: "Buscar nas mensagens…",
                      onKeydown: [
                        _cache[34] || (_cache[34] = _withKeys(
//@ts-ignore
(...args) => (_unref(doMsgSearch) && _unref(doMsgSearch)(...args)), ["enter"])),
                        _cache[35] || (_cache[35] = _withKeys(
//@ts-ignore
(...args) => (_unref(closeMsgSearch) && _unref(closeMsgSearch)(...args)), ["escape"]))
                      ]
                    }, null, 544), [
                      [_vModelText, _unref(msgSearchQuery)]
                    ]),
                    (_unref(msgSearchActive))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_unref(msgMatchIds).length ? (_unref(msgCurrentIdx) + 1) + '/' + _unref(msgMatchIds).length : '0 resultados'), 1))
                      : _createCommentVNode("", true),
                    (_unref(msgMatchIds).length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "fcw-msg-search-nav",
                          onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_unref(goPrevMsg) && _unref(goPrevMsg)(...args))),
                          title: "Anterior"
                        }, [...(_cache[108] || (_cache[108] = [
                          _createElementVNode("svg", {
                            width: "10",
                            height: "10",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("polyline", { points: "18 15 12 9 6 15" })
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_unref(msgMatchIds).length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "fcw-msg-search-nav",
                          onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_unref(goNextMsg) && _unref(goNextMsg)(...args))),
                          title: "Próximo"
                        }, [...(_cache[109] || (_cache[109] = [
                          _createElementVNode("svg", {
                            width: "10",
                            height: "10",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "fcw-msg-search-close",
                      onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_unref(closeMsgSearch) && _unref(closeMsgSearch)(...args)))
                    }, [...(_cache[110] || (_cache[110] = [
                      _createElementVNode("svg", {
                        width: "10",
                        height: "10",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("line", {
                          x1: "18",
                          y1: "6",
                          x2: "6",
                          y2: "18"
                        }),
                        _createElementVNode("line", {
                          x1: "6",
                          y1: "6",
                          x2: "18",
                          y2: "18"
                        })
                      ], -1)
                    ]))])
                  ], 32))
                : _createCommentVNode("", true),
              (macroPanelOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _cache[111] || (_cache[111] = _createElementVNode("svg", {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("circle", {
                            cx: "11",
                            cy: "11",
                            r: "8"
                          }),
                          _createElementVNode("line", {
                            x1: "21",
                            y1: "21",
                            x2: "16.65",
                            y2: "16.65"
                          })
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((macroSearch).value = $event)),
                          class: "fcw-macro-search",
                          placeholder: "Buscar macro…",
                          onClick: _cache[41] || (_cache[41] = _withModifiers(() => {}, ["stop"])),
                          onKeydown: _cache[42] || (_cache[42] = _withModifiers(() => {}, ["stop"]))
                        }, null, 544), [
                          [_vModelText, macroSearch.value]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_64, _toDisplayString(filteredMacros.value.length), 1)
                    ]),
                    (macrosLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [...(_cache[112] || (_cache[112] = [
                          _createElementVNode("span", {
                            class: "fcw-spinner",
                            style: {"width":"16px","height":"16px","border-width":"2px"}
                          }, null, -1)
                        ]))]))
                      : (macroRunning.value || macroRunDone.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                              _createElementVNode("button", {
                                class: "fcw-macro-back",
                                onClick: resetMacroRun,
                                disabled: macroRunning.value
                              }, [...(_cache[113] || (_cache[113] = [
                                _createElementVNode("svg", {
                                  width: "11",
                                  height: "11",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("path", { d: "M15 18l-6-6 6-6" })
                                ], -1),
                                _createTextVNode(" Voltar ", -1)
                              ]))], 8, _hoisted_68),
                              _createElementVNode("span", null, _toDisplayString(macroRunningObj.value?.name), 1)
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(macroStepResults.value, (r, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: i,
                                  class: _normalizeClass(["fcw-macro-step", r.ok ? 'fcw-macro-step--ok' : 'fcw-macro-step--err'])
                                }, [
                                  _createElementVNode("span", _hoisted_70, [
                                    (r.ok)
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_71, [...(_cache[114] || (_cache[114] = [
                                          _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("svg", _hoisted_72, [...(_cache[115] || (_cache[115] = [
                                          _createElementVNode("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                          }, null, -1),
                                          _createElementVNode("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                          }, null, -1)
                                        ]))]))
                                  ]),
                                  _createElementVNode("div", _hoisted_73, [
                                    _createElementVNode("div", _hoisted_74, _toDisplayString(r.label), 1),
                                    (!r.ok)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(r.msg), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 2))
                              }), 128)),
                              (macroRunning.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                    _cache[116] || (_cache[116] = _createElementVNode("span", { class: "fcw-macro-step-spin" }, null, -1)),
                                    _createElementVNode("div", _hoisted_77, [
                                      _createElementVNode("div", _hoisted_78, _toDisplayString(macroRunningObj.value?.actions[macroStepResults.value.length]
                       ? (_unref(MACRO_ACTION_LABELS)[macroRunningObj.value.actions[macroStepResults.value.length].action_name] ?? '…')
                       : '…'), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (macroRunDone.value)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["fcw-macro-summary", macroStepResults.value.every(r => r.ok) ? 'fcw-macro-summary--ok' : 'fcw-macro-summary--warn'])
                                }, [
                                  (macroStepResults.value.every(r => r.ok))
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_79, [...(_cache[117] || (_cache[117] = [
                                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                                      ]))]))
                                    : (_openBlock(), _createElementBlock("svg", _hoisted_80, [...(_cache[118] || (_cache[118] = [
                                        _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }, null, -1),
                                        _createElementVNode("line", {
                                          x1: "12",
                                          y1: "9",
                                          x2: "12",
                                          y2: "13"
                                        }, null, -1),
                                        _createElementVNode("line", {
                                          x1: "12",
                                          y1: "17",
                                          x2: "12.01",
                                          y2: "17"
                                        }, null, -1)
                                      ]))])),
                                  (macroStepResults.value.every(r => r.ok))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_81, "Concluído com sucesso!"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(macroStepResults.value.filter(r => !r.ok).length) + " ação(ões) com erro", 1))
                                ], 2))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            (!macrosList.value.length && !macrosLoading.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_84, " Nenhuma macro encontrada. "))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMacros.value, (m) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: m.id,
                                class: "fcw-macro-item",
                                onClick: _withModifiers(($event: any) => (runMacroInChat(m)), ["stop"])
                              }, [
                                _createElementVNode("div", _hoisted_86, [
                                  _createElementVNode("span", _hoisted_87, _toDisplayString(m.name), 1),
                                  _createElementVNode("span", _hoisted_88, _toDisplayString(m.actions.length) + " ação" + _toDisplayString(m.actions.length !== 1 ? 'ões' : ''), 1)
                                ]),
                                _cache[119] || (_cache[119] = _createElementVNode("svg", {
                                  class: "fcw-macro-item-run",
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2.5",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" })
                                ], -1))
                              ], 8, _hoisted_85))
                            }), 128))
                          ]))
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", {
                class: "fcw-msgs",
                ref_key: "msgsEl",
                ref: msgsEl,
                onScroll: onMsgsScroll
              }, [
                (loadingMsgs.value || _unref(msgSearchLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                      _cache[120] || (_cache[120] = _createElementVNode("span", { class: "fcw-spinner" }, null, -1)),
                      (_unref(msgSearchLoading))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Buscando em toda a conversa…"))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (loadingMore.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [...(_cache[121] || (_cache[121] = [
                            _createElementVNode("span", { class: "fcw-spinner-sm" }, null, -1)
                          ]))]))
                        : (noMoreMsgs.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_92, "início da conversa"))
                          : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedMsgs.value, (msg) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: msg.id,
                          class: _normalizeClass(["fcw-msg-row", { out: msg.message_type === 1, inn: msg.message_type === 0, act: msg.message_type === 2, 'msg-match-current': _unref(msgSearchActive) && _unref(msgMatchIds)[_unref(msgCurrentIdx)] === msg.id }]),
                          "data-msg-id": msg.id
                        }, [
                          (msg.message_type === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(msg.content), 1))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (msg.showAvatar)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "fcw-msg-av",
                                      style: _normalizeStyle({ background: _unref(avatarColor)(senderName(msg)) }),
                                      title: senderName(msg)
                                    }, [
                                      (msg.sender?.thumbnail && msg.message_type === 1)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: msg.sender.thumbnail,
                                            onError: _cache[43] || (_cache[43] = (e) => (e.target as HTMLImageElement).style.display='none')
                                          }, null, 40, _hoisted_96))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(_unref(initials)(senderName(msg))), 1))
                                    ], 12, _hoisted_95))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_98)),
                                _createElementVNode("div", _hoisted_99, [
                                  (msg.private)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_100, [...(_cache[122] || (_cache[122] = [
                                        _createElementVNode("svg", {
                                          width: "10",
                                          height: "10",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("rect", {
                                            x: "3",
                                            y: "11",
                                            width: "18",
                                            height: "11",
                                            rx: "2"
                                          }),
                                          _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                                        ], -1),
                                        _createTextVNode(" Nota interna ", -1)
                                      ]))]))
                                    : _createCommentVNode("", true),
                                  (msg.content)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        class: _normalizeClass(["fcw-bubble-text", { 'fcw-bubble-text--priv': msg.private }]),
                                        innerHTML: _unref(highlightMsgHtml)(msg.content, msg.message_type === 1, authUser.value?.message_signature)
                                      }, null, 10, _hoisted_101))
                                    : _createCommentVNode("", true),
                                  (msg.message_type === 1 && _unref(extractFileKey)(msg.content || ''))
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 2,
                                        href: _unref(n8nDownloadUrl)(_unref(extractFileKey)(msg.content || '')),
                                        target: "_blank",
                                        rel: "noopener",
                                        class: "fcw-file-dl-btn"
                                      }, [...(_cache[123] || (_cache[123] = [
                                        _createElementVNode("svg", {
                                          width: "11",
                                          height: "11",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                                          _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
                                          _createElementVNode("line", {
                                            x1: "12",
                                            y1: "15",
                                            x2: "12",
                                            y2: "3"
                                          })
                                        ], -1),
                                        _createTextVNode(" Baixar arquivo ", -1)
                                      ]))], 8, _hoisted_102))
                                    : _createCommentVNode("", true),
                                  (msg.attachments?.length)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(msg.attachments, (att) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: att.id,
                                          class: "fcw-att"
                                        }, [
                                          (att.file_type === 'image')
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: att.data_url,
                                                target: "_blank",
                                                rel: "noopener",
                                                class: "fcw-att-img-wrap"
                                              }, [
                                                _createElementVNode("img", {
                                                  src: att.thumb_url || att.data_url,
                                                  class: "fcw-att-img",
                                                  loading: "lazy"
                                                }, null, 8, _hoisted_104)
                                              ], 8, _hoisted_103))
                                            : (att.file_type === 'audio')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                                  _createElementVNode("button", {
                                                    class: "fcw-ap-btn",
                                                    onClick: ($event: any) => (_unref(toggleAudio)(att))
                                                  }, [
                                                    (_unref(audioState)[att.id]?.playing)
                                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_107, [...(_cache[124] || (_cache[124] = [
                                                          _createElementVNode("rect", {
                                                            x: "6",
                                                            y: "4",
                                                            width: "4",
                                                            height: "16"
                                                          }, null, -1),
                                                          _createElementVNode("rect", {
                                                            x: "14",
                                                            y: "4",
                                                            width: "4",
                                                            height: "16"
                                                          }, null, -1)
                                                        ]))]))
                                                      : (_openBlock(), _createElementBlock("svg", _hoisted_108, [...(_cache[125] || (_cache[125] = [
                                                          _createElementVNode("polygon", { points: "5 3 19 12 5 21 5 3" }, null, -1)
                                                        ]))]))
                                                  ], 8, _hoisted_106),
                                                  _createElementVNode("div", _hoisted_109, [
                                                    _createElementVNode("div", {
                                                      class: "fcw-ap-bar",
                                                      onClick: _cache[44] || (_cache[44] = _withModifiers(() => {}, ["stop"]))
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: "fcw-ap-fill",
                                                        style: _normalizeStyle({ width: _unref(audioProgress)(att.id)+'%' })
                                                      }, null, 4),
                                                      _createElementVNode("input", {
                                                        type: "range",
                                                        class: "fcw-ap-seek",
                                                        min: "0",
                                                        max: "100",
                                                        step: "0.1",
                                                        value: _unref(audioProgress)(att.id),
                                                        onInput: ($event: any) => (_unref(seekAudio)(att, $event))
                                                      }, null, 40, _hoisted_110)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_111, [
                                                      _createElementVNode("span", null, _toDisplayString(_unref(fmtTime)(_unref(audioState)[att.id]?.current || 0)), 1),
                                                      _createElementVNode("span", null, _toDisplayString(_unref(fmtTime)(_unref(audioState)[att.id]?.duration || 0)), 1)
                                                    ])
                                                  ]),
                                                  _createElementVNode("a", {
                                                    href: att.data_url,
                                                    target: "_blank",
                                                    rel: "noopener",
                                                    class: "fcw-ap-dl",
                                                    title: "Baixar"
                                                  }, [...(_cache[126] || (_cache[126] = [
                                                    _createElementVNode("svg", {
                                                      width: "12",
                                                      height: "12",
                                                      viewBox: "0 0 24 24",
                                                      fill: "none",
                                                      stroke: "currentColor",
                                                      "stroke-width": "2.5",
                                                      "stroke-linecap": "round",
                                                      "stroke-linejoin": "round"
                                                    }, [
                                                      _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                                                      _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
                                                      _createElementVNode("line", {
                                                        x1: "12",
                                                        y1: "15",
                                                        x2: "12",
                                                        y2: "3"
                                                      })
                                                    ], -1)
                                                  ]))], 8, _hoisted_112)
                                                ]))
                                              : (_unref(isVideo)(att))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                                                    _createElementVNode("video", {
                                                      src: att.data_url,
                                                      controls: "",
                                                      preload: "metadata",
                                                      class: "fcw-att-video"
                                                    }, null, 8, _hoisted_114)
                                                  ]))
                                                : (_unref(isPdf)(att))
                                                  ? (_openBlock(), _createElementBlock("a", {
                                                      key: 3,
                                                      href: att.data_url,
                                                      target: "_blank",
                                                      rel: "noopener",
                                                      class: "fcw-att-file fcw-att-pdf"
                                                    }, [
                                                      _cache[128] || (_cache[128] = _createElementVNode("svg", {
                                                        width: "16",
                                                        height: "16",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        "stroke-width": "1.8",
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round"
                                                      }, [
                                                        _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
                                                        _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
                                                      ], -1)),
                                                      _createElementVNode("div", _hoisted_116, [
                                                        _cache[127] || (_cache[127] = _createElementVNode("span", { class: "fcw-att-ext" }, "PDF", -1)),
                                                        _createElementVNode("span", _hoisted_117, _toDisplayString(_unref(fmtSize)(att.file_size)), 1)
                                                      ])
                                                    ], 8, _hoisted_115))
                                                  : (_openBlock(), _createElementBlock("a", {
                                                      key: 4,
                                                      href: att.data_url,
                                                      target: "_blank",
                                                      rel: "noopener",
                                                      class: "fcw-att-file"
                                                    }, [
                                                      _cache[129] || (_cache[129] = _createElementVNode("svg", {
                                                        width: "14",
                                                        height: "14",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        "stroke-width": "2",
                                                        "stroke-linecap": "round",
                                                        "stroke-linejoin": "round"
                                                      }, [
                                                        _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
                                                        _createElementVNode("polyline", { points: "14 2 14 8 20 8" })
                                                      ], -1)),
                                                      _createElementVNode("div", _hoisted_119, [
                                                        _createElementVNode("span", _hoisted_120, _toDisplayString(att.extension?.toUpperCase() || 'Arquivo'), 1),
                                                        _createElementVNode("span", _hoisted_121, _toDisplayString(_unref(fmtSize)(att.file_size)), 1)
                                                      ])
                                                    ], 8, _hoisted_118))
                                        ]))
                                      }), 128))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("span", _hoisted_122, [
                                    _createTextVNode(_toDisplayString(fmtTs(msg.created_at)) + " ", 1),
                                    (msg.message_type === 1)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: _normalizeClass(["fcw-msg-status", 's-'+(msg.status||'sent')]),
                                          title: msg.status === 'read' ? 'Lido' : msg.status === 'delivered' ? 'Entregue' : msg.status === 'failed' ? 'Falhou' : 'Enviado'
                                        }, [
                                          (msg.status === 'failed')
                                            ? (_openBlock(), _createElementBlock("svg", _hoisted_124, [...(_cache[130] || (_cache[130] = [
                                                _createElementVNode("line", {
                                                  x1: "1",
                                                  y1: "1",
                                                  x2: "7",
                                                  y2: "7"
                                                }, null, -1),
                                                _createElementVNode("line", {
                                                  x1: "7",
                                                  y1: "1",
                                                  x2: "1",
                                                  y2: "7"
                                                }, null, -1)
                                              ]))]))
                                            : (msg.status === 'read' || msg.status === 'delivered')
                                              ? (_openBlock(), _createElementBlock("svg", _hoisted_125, [...(_cache[131] || (_cache[131] = [
                                                  _createElementVNode("polyline", { points: "1,4 3.5,6.5 9,1" }, null, -1),
                                                  _createElementVNode("polyline", { points: "5,4 7.5,6.5 13,1" }, null, -1)
                                                ]))]))
                                              : (_openBlock(), _createElementBlock("svg", _hoisted_126, [...(_cache[132] || (_cache[132] = [
                                                  _createElementVNode("polyline", { points: "1,4 3.5,6.5 9,1" }, null, -1)
                                                ]))]))
                                        ], 10, _hoisted_123))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ], 64))
                        ], 10, _hoisted_93))
                      }), 128))
                    ], 64))
              ], 544), [
                [_vShow, !macroPanelOpen.value]
              ]),
              (isReadOnly.value && !macroPanelOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_127, [...(_cache[133] || (_cache[133] = [
                    _createElementVNode("svg", {
                      width: "13",
                      height: "13",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("polyline", { points: "20 6 9 17 4 12" })
                    ], -1),
                    _createTextVNode(" Conversa resolvida — somente leitura ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_unref(isWindowClosed) && !isReadOnly.value && !macroPanelOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_128, [...(_cache[134] || (_cache[134] = [
                    _createElementVNode("svg", {
                      width: "13",
                      height: "13",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("circle", {
                        cx: "12",
                        cy: "12",
                        r: "10"
                      }),
                      _createElementVNode("line", {
                        x1: "12",
                        y1: "8",
                        x2: "12",
                        y2: "12"
                      }),
                      _createElementVNode("line", {
                        x1: "12",
                        y1: "16",
                        x2: "12.01",
                        y2: "16"
                      })
                    ], -1),
                    _createTextVNode(" Você só pode responder usando um template — janela de 24h do WhatsApp encerrada ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (!isReadOnly.value && !macroPanelOpen.value && attachFiles.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachFiles.value, (f, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "fcw-file-pill"
                      }, [
                        _cache[135] || (_cache[135] = _createElementVNode("svg", {
                          width: "10",
                          height: "10",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
                        ], -1)),
                        _createElementVNode("span", null, _toDisplayString(f.name), 1),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (attachFiles.value.splice(i,1))
                        }, "×", 8, _hoisted_130)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!isReadOnly.value && !macroPanelOpen.value && !_unref(recording) && !_unref(recordedBlob))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 6,
                    class: _normalizeClass(["fcw-composer", { 'fcw-composer--priv': notaInterna.value }])
                  }, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["fcw-attach", { 'fcw-attach-disabled': _unref(isWindowClosed) || notaInterna.value }]),
                      title: "Anexar"
                    }, [
                      _createElementVNode("input", {
                        type: "file",
                        multiple: "",
                        hidden: "",
                        ref_key: "fileInputEl",
                        ref: fileInputEl,
                        disabled: _unref(isWindowClosed) || notaInterna.value,
                        onChange: onFilePick
                      }, null, 40, _hoisted_131),
                      _cache[136] || (_cache[136] = _createElementVNode("svg", {
                        width: "15",
                        height: "15",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" })
                      ], -1))
                    ], 2),
                    (_unref(can)('messages.privateNote'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["fcw-priv-btn", { 'fcw-priv-btn--active': notaInterna.value }]),
                          disabled: _unref(isWindowClosed),
                          onClick: _cache[45] || (_cache[45] = ($event: any) => (notaInterna.value = !notaInterna.value)),
                          title: notaInterna.value ? 'Nota interna ativada — clique para voltar ao modo normal' : 'Marcar como nota interna (não visível pro cliente)'
                        }, [...(_cache[137] || (_cache[137] = [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("rect", {
                              x: "3",
                              y: "11",
                              width: "18",
                              height: "11",
                              rx: "2"
                            }),
                            _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                          ], -1)
                        ]))], 10, _hoisted_132))
                      : _createCommentVNode("", true),
                    (!_unref(isWindowClosed))
                      ? (_openBlock(), _createBlock(EmojiPicker, {
                          key: 1,
                          onPick: insertEmoji
                        }))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("textarea", {
                      ref_key: "taEl",
                      ref: taEl,
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((draft).value = $event)),
                      class: "fcw-ta",
                      placeholder: notaInterna.value ? 'Nota interna — só a equipe vê… (Enter envia)' : (_unref(isWindowClosed) ? 'Envie um template para responder…' : 'Mensagem… (Enter envia)'),
                      disabled: _unref(isWindowClosed),
                      rows: "1",
                      onKeydown: _cache[47] || (_cache[47] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_unref(sendMsg) && _unref(sendMsg)(...args)), ["exact","prevent"]), ["enter"])),
                      onInput: growTa
                    }, null, 40, _hoisted_133), [
                      [_vModelText, draft.value]
                    ]),
                    (!notaInterna.value && (_unref(isWindowClosed) || (!canSend.value && !_unref(sending))))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("button", {
                            class: "fcw-wa-tpl",
                            onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_unref(openTplModal) && _unref(openTplModal)(...args))),
                            title: "Enviar template WhatsApp"
                          }, [...(_cache[138] || (_cache[138] = [
                            _createElementVNode("svg", {
                              width: "15",
                              height: "15",
                              viewBox: "0 0 24 24",
                              fill: "currentColor",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zm8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" })
                            ], -1)
                          ]))]),
                          (!_unref(isWindowClosed))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "fcw-mic",
                                onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_unref(startRecording) && _unref(startRecording)(...args))),
                                title: "Gravar áudio"
                              }, [...(_cache[139] || (_cache[139] = [
                                _createElementVNode("svg", {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2.2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("path", { d: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" }),
                                  _createElementVNode("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }),
                                  _createElementVNode("line", {
                                    x1: "12",
                                    y1: "19",
                                    x2: "12",
                                    y2: "23"
                                  }),
                                  _createElementVNode("line", {
                                    x1: "8",
                                    y1: "23",
                                    x2: "16",
                                    y2: "23"
                                  })
                                ], -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "fcw-send",
                          onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_unref(sendMsg) && _unref(sendMsg)(...args))),
                          disabled: !canSend.value || _unref(sending)
                        }, [
                          (_unref(sending))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_135))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_136, [...(_cache[140] || (_cache[140] = [
                                _createElementVNode("line", {
                                  x1: "22",
                                  y1: "2",
                                  x2: "11",
                                  y2: "13"
                                }, null, -1),
                                _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" }, null, -1)
                              ]))]))
                        ], 8, _hoisted_134))
                  ], 2))
                : (!isReadOnly.value && !macroPanelOpen.value && _unref(recording))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                      _createElementVNode("button", {
                        class: "fcw-rec-cancel",
                        onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_unref(cancelRecording) && _unref(cancelRecording)(...args))),
                        title: "Cancelar"
                      }, [...(_cache[141] || (_cache[141] = [
                        _createElementVNode("svg", {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "3",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("line", {
                            x1: "18",
                            y1: "6",
                            x2: "6",
                            y2: "18"
                          }),
                          _createElementVNode("line", {
                            x1: "6",
                            y1: "6",
                            x2: "18",
                            y2: "18"
                          })
                        ], -1)
                      ]))]),
                      _cache[143] || (_cache[143] = _createElementVNode("span", { class: "fcw-rec-dot" }, null, -1)),
                      _createElementVNode("div", _hoisted_138, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(waveformBars), (h, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: i,
                            class: "fcw-rec-bar",
                            style: _normalizeStyle({ height: h+'px' })
                          }, null, 4))
                        }), 128))
                      ]),
                      _createElementVNode("span", _hoisted_139, _toDisplayString(_unref(fmtRecTime)(_unref(recordingTime))), 1),
                      _createElementVNode("button", {
                        class: "fcw-rec-stop",
                        onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_unref(stopRecording) && _unref(stopRecording)(...args))),
                        title: "Parar"
                      }, [...(_cache[142] || (_cache[142] = [
                        _createElementVNode("svg", {
                          width: "13",
                          height: "13",
                          viewBox: "0 0 24 24",
                          fill: "currentColor"
                        }, [
                          _createElementVNode("rect", {
                            x: "4",
                            y: "4",
                            width: "16",
                            height: "16",
                            rx: "2"
                          })
                        ], -1)
                      ]))])
                    ]))
                  : (!isReadOnly.value && !macroPanelOpen.value && _unref(recordedBlob))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                        _createElementVNode("button", {
                          class: "fcw-rec-cancel",
                          onClick: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_unref(cancelRecording) && _unref(cancelRecording)(...args))),
                          title: "Descartar"
                        }, [...(_cache[144] || (_cache[144] = [
                          _createElementVNode("svg", {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "3",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("line", {
                              x1: "18",
                              y1: "6",
                              x2: "6",
                              y2: "18"
                            }),
                            _createElementVNode("line", {
                              x1: "6",
                              y1: "6",
                              x2: "18",
                              y2: "18"
                            })
                          ], -1)
                        ]))]),
                        _createElementVNode("audio", {
                          src: _unref(recordedUrl),
                          controls: "",
                          preload: "auto",
                          class: "fcw-rec-audio"
                        }, null, 8, _hoisted_141),
                        _createElementVNode("button", {
                          class: "fcw-rec-send",
                          onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_unref(sendRecordedAudio) && _unref(sendRecordedAudio)(...args))),
                          title: "Enviar"
                        }, [...(_cache[145] || (_cache[145] = [
                          _createElementVNode("svg", {
                            width: "13",
                            height: "13",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("line", {
                              x1: "22",
                              y1: "2",
                              x2: "11",
                              y2: "13"
                            }),
                            _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" })
                          ], -1)
                        ]))])
                      ]))
                    : _createCommentVNode("", true),
              (!isPipped.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                    _createElementVNode("div", {
                      class: "fcw-resize-se",
                      onMousedown: _cache[55] || (_cache[55] = _withModifiers(($event: any) => (startResize('se')), ["prevent"]))
                    }, null, 32),
                    _createElementVNode("div", {
                      class: "fcw-resize-s",
                      onMousedown: _cache[56] || (_cache[56] = _withModifiers(($event: any) => (startResize('s')), ["prevent"]))
                    }, null, 32),
                    _createElementVNode("div", {
                      class: "fcw-resize-e",
                      onMousedown: _cache[57] || (_cache[57] = _withModifiers(($event: any) => (startResize('e')), ["prevent"]))
                    }, null, 32),
                    _createElementVNode("div", {
                      class: "fcw-resize-w",
                      onMousedown: _cache[58] || (_cache[58] = _withModifiers(($event: any) => (startResize('w')), ["prevent"]))
                    }, null, 32)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ], 38)
    ], 8, ["to"])),
    (_openBlock(), _createBlock(_Teleport, { to: teleportTarget.value }, [
      (_unref(tplModalOpen))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fcw-tpl-overlay",
            onMousedown: _cache[64] || (_cache[64] = _withModifiers(
//@ts-ignore
(...args) => (_unref(closeTplModal) && _unref(closeTplModal)(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_142, [
              _createElementVNode("div", _hoisted_143, [
                _createElementVNode("div", _hoisted_144, [
                  _cache[146] || (_cache[146] = _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "#25D366"
                  }, [
                    _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884zm8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" })
                  ], -1)),
                  _cache[147] || (_cache[147] = _createTextVNode(" Enviar Template WhatsApp ", -1)),
                  _createElementVNode("span", _hoisted_145, "→ " + _toDisplayString(props.win.conv.contact.name), 1)
                ]),
                _createElementVNode("button", {
                  class: "fcw-tpl-close",
                  onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_unref(closeTplModal) && _unref(closeTplModal)(...args)))
                }, [...(_cache[148] || (_cache[148] = [
                  _createElementVNode("svg", {
                    width: "15",
                    height: "15",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5"
                  }, [
                    _createElementVNode("path", { d: "M18 6 6 18M6 6l12 12" })
                  ], -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_146, [
                _createElementVNode("div", _hoisted_147, [
                  _cache[150] || (_cache[150] = _createElementVNode("div", { class: "fcw-tpl-col-label" }, "Templates aprovados", -1)),
                  (_unref(tplsLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_148, [...(_cache[149] || (_cache[149] = [
                        _createElementVNode("span", { class: "fcw-tpl-spin" }, null, -1),
                        _createTextVNode(" Carregando… ", -1)
                      ]))]))
                    : (!_unref(tplsApproved).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_149, "Nenhum template aprovado"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_150, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tplsApproved), (t) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: t.id,
                              class: _normalizeClass(["fcw-tpl-item", { active: _unref(tplSelected)?.id === t.id }]),
                              onClick: ($event: any) => (_unref(selectTpl)(t))
                            }, [
                              _createElementVNode("div", _hoisted_152, _toDisplayString(t.name.replace(/_/g,' ')), 1),
                              _createElementVNode("div", _hoisted_153, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["fcw-tpl-cat", t.category.toLowerCase()])
                                }, _toDisplayString(t.category === 'MARKETING' ? 'Marketing' : t.category === 'UTILITY' ? 'Utilidade' : t.category), 3),
                                _createElementVNode("span", _hoisted_154, _toDisplayString(t.language), 1)
                              ])
                            ], 10, _hoisted_151))
                          }), 128))
                        ]))
                ]),
                _createElementVNode("div", _hoisted_155, [
                  (!_unref(tplSelected))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_156, [...(_cache[151] || (_cache[151] = [
                        _createElementVNode("svg", {
                          width: "28",
                          height: "28",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "1.5"
                        }, [
                          _createElementVNode("path", { d: "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" }),
                          _createElementVNode("rect", {
                            x: "9",
                            y: "3",
                            width: "6",
                            height: "4",
                            rx: "1"
                          })
                        ], -1),
                        _createElementVNode("span", null, "Selecione um template ao lado", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[158] || (_cache[158] = _createElementVNode("div", {
                          class: "fcw-tpl-col-label",
                          style: {"margin-bottom":"8px"}
                        }, [
                          _createElementVNode("svg", {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            _createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "3"
                            })
                          ]),
                          _createTextVNode(" Preview em tempo real ")
                        ], -1)),
                        _createElementVNode("div", _hoisted_157, [
                          _createElementVNode("div", _hoisted_158, [
                            (_unref(tplHasImg))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                                  (_unref(tplImgUrl) && !_unref(tplImgErr))
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _unref(tplImgUrl),
                                        alt: "",
                                        onError: _cache[60] || (_cache[60] = ($event: any) => (tplImgErr.value = true))
                                      }, null, 40, _hoisted_160))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_161, [...(_cache[152] || (_cache[152] = [
                                        _createElementVNode("svg", {
                                          width: "22",
                                          height: "22",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "1.5"
                                        }, [
                                          _createElementVNode("rect", {
                                            x: "3",
                                            y: "3",
                                            width: "18",
                                            height: "18",
                                            rx: "2"
                                          }),
                                          _createElementVNode("circle", {
                                            cx: "8.5",
                                            cy: "8.5",
                                            r: "1.5"
                                          }),
                                          _createElementVNode("path", { d: "M21 15l-5-5L5 21" })
                                        ], -1)
                                      ]))]))
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(tplHeaderTxt))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_162, _toDisplayString(_unref(tplHeaderTxt)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: "fcw-tpl-bubble-body",
                              innerHTML: _unref(tplPreviewHtml)
                            }, null, 8, _hoisted_163),
                            (_unref(tplFooterTxt))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_164, _toDisplayString(_unref(tplFooterTxt)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_165, _toDisplayString(_unref(tplTime)), 1)
                          ]),
                          (_unref(tplButtons).length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tplButtons), (b, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "fcw-tpl-btn"
                                  }, _toDisplayString(b.text || 'Botão'), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_unref(tplHasImg))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                              _cache[153] || (_cache[153] = _createElementVNode("div", { class: "fcw-tpl-field-label" }, "URL da imagem", -1)),
                              _withDirectives(_createElementVNode("input", {
                                type: "url",
                                class: "fcw-tpl-input",
                                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => (_isRef(tplImgUrl) ? (tplImgUrl).value = $event : null)),
                                placeholder: "https://…",
                                onInput: _cache[62] || (_cache[62] = ($event: any) => (tplImgErr.value = false))
                              }, null, 544), [
                                [_vModelText, _unref(tplImgUrl)]
                              ]),
                              _cache[154] || (_cache[154] = _createElementVNode("div", { class: "fcw-tpl-hint" }, "Use uma URL pública permanente", -1))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(tplVarNums).length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                              _cache[156] || (_cache[156] = _createElementVNode("div", {
                                class: "fcw-tpl-col-label",
                                style: {"margin-bottom":"6px"}
                              }, "Variáveis", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tplVarNums), (n) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: n,
                                  style: {"margin-bottom":"7px"}
                                }, [
                                  _createElementVNode("div", _hoisted_169, "Variável {{" + _toDisplayString(n) + "}}", 1),
                                  (_unref(tplVarMapping)[n])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                        _cache[155] || (_cache[155] = _createElementVNode("svg", {
                                          width: "12",
                                          height: "12",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2.5",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round"
                                        }, [
                                          _createElementVNode("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
                                          _createElementVNode("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
                                        ], -1)),
                                        _createTextVNode(" Preenchido automaticamente: " + _toDisplayString(_unref(mappedLabel)(n)), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        type: "text",
                                        class: "fcw-tpl-input",
                                        placeholder: `Valor para {{${n}}}`,
                                        value: _unref(tplVars)[n] || '',
                                        onInput: ($event: any) => (_unref(setTplVar)(n, ($event.target as HTMLInputElement).value))
                                      }, null, 40, _hoisted_171))
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_172, [
                          (_unref(tplSendBlocked))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_173, _toDisplayString(_unref(tplSendBlockedReason)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "fcw-tpl-send-btn",
                            disabled: _unref(tplSending) || _unref(tplSendBlocked),
                            title: _unref(tplSendBlockedReason),
                            onClick: _cache[63] || (_cache[63] = 
//@ts-ignore
(...args) => (_unref(sendTplToContact) && _unref(sendTplToContact)(...args)))
                          }, [
                            (!_unref(tplSending))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_175, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_176, [...(_cache[157] || (_cache[157] = [
                                    _createElementVNode("line", {
                                      x1: "22",
                                      y1: "2",
                                      x2: "11",
                                      y2: "13"
                                    }, null, -1),
                                    _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" }, null, -1)
                                  ]))])),
                                  _createTextVNode(" Enviar para " + _toDisplayString(props.win.conv.contact.name), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_177))
                          ], 8, _hoisted_174)
                        ])
                      ], 64))
                ])
              ])
            ])
          ], 32))
        : _createCommentVNode("", true)
    ], 8, ["to"]))
  ], 64))
}
}

})